import Vue from 'vue'
import Router from 'vue-router'

import { clearLoginInfo } from '@/utils'
import { isURL } from '@/utils/validate'
import { menuApi,permissionApi} from "@/api/sys";
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'
import i18n from '../lang'
import Cookies from 'js-cookie'
import { LINUX_AUTO_MENU_IDS } from '@/constants/linuxAutoPortal'
import { SUPPORT_TICKET_MENU_IDS } from '@/constants/supportTicket'
import { DEVICE_SERVICE_MENU_IDS } from '@/constants/deviceService'
import { STORE_MATERIAL_MENU_IDS } from '@/constants/storeMaterial'
import { TEA_MACHINE_MATERIAL_MENU_IDS } from '@/constants/teaMachineMaterial'
import { TEA_SINGLE_CUP_PARAMS_MENU_IDS } from '@/constants/teaSingleCupParams'
import { TEA_EARLY_BREW_WORK_MENU_IDS } from '@/constants/teaEarlyBrewWork'
import { TEA_E1_PERFORMANCE_MENU_IDS } from '@/constants/teaE1Performance'
import { ECOSYSTEM_MALL_MENU_IDS } from '@/constants/ecosystemMall'
import { STORE_ASSORTMENT_MENU_IDS } from '@/constants/storeAssortment'
import { FINANCE_ACCOUNTING_MENU_IDS } from '@/constants/financeAccounting'
import { STORE_COST_OPTIMIZE_MENU_IDS } from '@/constants/storeCostOptimize'
import { STORE_AUTONOMOUS_MARKETING_MENU_IDS } from '@/constants/storeAutonomousMarketing'
import { STORE_OPS_CEO_DESK_MENU_IDS } from '@/constants/storeOpsCeoDesk'
import { AI_ENGINEERING_CONTROL_MENU_IDS } from '@/constants/aiEngineeringControl'
import { STORE_PNL_MENU_IDS } from '@/constants/storePnL'
import { HK_TAX_FILING_MENU_IDS } from '@/constants/hkTaxFiling'
import { XHM_HARDWARE_PARTNER_MENU_IDS } from '@/constants/xhmHardwarePartner'
import { XHM_FAMILY_SLOT_MENU_IDS } from '@/constants/xhmFamilySlot'
import { LEO_BRAND_ONBOARDING_MENU_IDS } from '@/constants/leoBrandOnboarding'
import { HK_MARKET_CHANNEL_MENU_IDS } from '@/constants/hkMarketChannel'
import { CN_MARKET_CHANNEL_MENU_IDS } from '@/constants/cnMarketChannel'
import { WORKFORCE_MENU_IDS } from '@/constants/workforce'
import { STORE_AUTOPILOT_MENU_IDS } from '@/constants/storeAutopilot'
import { XRROSS_INTRO_ROUTE } from '@/constants/xrrossIntro'
import { AFTER_SALES_SERVICE_MENU_IDS } from '@/constants/afterSalesService'
import {
  LEO_KNOWLEDGE_MENU_IDS,
  LEO_SIDEBAR_FOLDER_IDS,
  SYSTEM_SETTINGS_PLATFORM_MENU_IDS,
  DEVICE_RD_SIDEBAR_MENU_IDS,
  buildLeoSidebarStripIdSet
} from '@/constants/sidebarMenuIdSsot'
import {
  buildSidebarNavTreeFromFlat,
  enrichSidebarNodesFromNavTree,
  flattenNavTreeToFlatList
} from '@/utils/menuDisplay'
import { stripLeoOpsFromSystemSettingsTree, reparentLeoOpsOutOfSystemSettings } from '@/utils/leoSystemSettingsMenuAlign'
import {
  canAccessSupportTicketCreate,
  canAccessSupportTicketMine,
  canAccessSupportTicketWorkbench
} from '@/utils/supportTicketPermissions'
import { dedupeRoutesByMenuIdPreferStatic } from '@/utils/sidebarRouteResolver'
import { isPlatformAdminFromStore } from '@/utils/platformAdmin'
import { stripUnassignedRbacSidebarMenus, pruneSidebarNodesByEnChecks, menuTreeContainsEnName, collectNavMenuIds, isNavAuthorizedMenuId } from '@/utils/sidebarPermissionFilter'
import { fillSidebarMenuIcons } from '@/utils/sidebarMenuIcons'
import {
  CHANNEL_CONFIG_CATALOG_ID,
  isChannelConfigExclusiveLeaf as isChannelConfigExclusiveMenuLeaf,
  isDeviceConfigExclusiveLeaf as isDeviceConfigExclusiveMenuLeaf,
  isMixedLegacyDeviceConfigRoot,
  partitionDeviceChannelLeaves
} from '@/utils/deviceChannelMenuSplit'
import { hasLeoPortalGate } from '@/utils/leoPortalGate'
// 开发环境不使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)
const RouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace= function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

function leoInternalRouteGuard (to, from, next) {
  if (hasLeoPortalGate(to.query)) {
    next()
    return
  }
  const query = { ...to.query }
  delete query.surface
  next({ name: 'leoStandaloneChat', query, replace: true })
}

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/404', component: _import('common/404/index'), name: '404', meta: { title: '' } },
  { path: '/login', component: _import('common/login/index'), name: 'login', meta: { title: '' } },
  { path: '/operation', component: _import('common/operation/index'), name: 'operation', meta: { title: '' } },
  { path: '/dataShow', component: _import('common/dataShow/index'), name: 'dataShow', meta: { title: '' } },
  { path: '/leoSmart-intro', component: _import('xrrossIntro/leoSmart/index'), name: 'leoSmartIntro', meta: { title: 'leoSmartIntro' } },
  { path: '/privacyAgreement', component: _import('common/login/privacy-agreement'), name: 'privacyAgreement', meta: { title: '' } },
  { path: '/privacyAgreement1', component: _import('common/login/privacy-agreement-1'), name: 'privacyAgreement1', meta: { title: '' } },
  { path: '/privacyAgreement2', component: _import('common/login/privacy-agreement-2'), name: 'privacyAgreement2', meta: { title: '' } },
  { path: '/membership/register', component: _import('membership/MembershipRegister'), name: 'membershipRegister', meta: { title: '會員註冊' } },
  { path: '/membership/login', component: _import('membership/MembershipLogin'), name: 'membershipLogin', meta: { title: '會員登入' } },
  { path: '/leo-portal', component: _import('leo/LeoBrainPortal'), name: 'leoPortal', meta: { title: 'Leo' }, beforeEnter: leoInternalRouteGuard },
  {
    path: '/leo',
    component: _import('leo/LeoHub'),
    redirect: '/leo/chat',
    children: [
      { path: 'chat', component: _import('leo/LeoStandaloneChat'), name: 'leoStandaloneChat', meta: { title: 'Leo' }, beforeEnter (to, from, next) {
        if (String(to.query.surface || '').trim().toLowerCase() === 'leosmart') {
          const query = { ...to.query }
          delete query.surface
          next({ path: to.path, query, hash: to.hash, replace: true })
          return
        }
        next()
      } },
      { path: 'billing', component: _import('leo/LeoBillingUsage'), name: 'leoBilling', meta: { title: 'Leo 用量與計費' } },
      { path: 'preferences', component: _import('leo/LeoMyPreferences'), name: 'leoMyPreferences', meta: { title: 'Leo 我的偏好' } },
      { path: 'console', component: _import('LeoBrainConsole'), name: 'leoConsole', meta: { title: 'Leo Console' }, beforeEnter: leoInternalRouteGuard },
      { path: 'login', component: _import('leo/LeoLogin'), name: 'leoLogin', meta: { title: 'Leo 登入' } },
      { path: 'membership-login', component: _import('membership/MembershipLogin'), name: 'leoMembershipLogin', meta: { title: '會員登入' } },
      { path: 'membership-register', component: _import('membership/MembershipRegister'), name: 'leoMembershipRegister', meta: { title: '會員註冊' } }
    ]
  },
  { path: '/leo-chat', redirect: '/leo/chat' },
  { path: '/leo-console', redirect: '/leo/chat' },
  { path: '/leo-login', redirect: '/leo/login' },
  {
    path: '/leo-device-integration',
    component: _import('common/leo-device-integration/LeoDeviceIntegrationPublic'),
    name: 'leoDeviceIntegrationPublic',
    meta: { title: 'Leo 裝置整合工具' }
  },
  {
    path: '/device-cloud-runtime',
    component: _import('common/device-cloud-runtime/DeviceCloudRuntimePublic'),
    name: 'deviceCloudRuntimePublic',
    meta: { title: 'XRROSS 裝置雲運行期模組' }
  },
  {
    path: '/xrross-sdk-engineer-lab',
    component: _import('common/sdk-engineer-lab/SdkEngineerLab'),
    name: 'xrrossSdkEngineerLab',
    meta: { title: 'XRROSS SDK 工程測試台' }
  },
  {
    path: '/support-ticket-h5',
    component: _import('support/ticket/h5/create'),
    name: 'support-ticket-h5',
    meta: {
      title: '手机提交工单',
      menuId: SUPPORT_TICKET_MENU_IDS.create,
      id: SUPPORT_TICKET_MENU_IDS.create,
      supportTicketPermission: 'support:ticket:create'
    }
  },
  {
    path: '/m/training-desk',
    component: _import('leoKnowledge/LeoTrainingDecisionDeskMobile'),
    name: 'leoTrainingDecisionDeskMobile',
    meta: { title: '训练决策台（手机）' }
  },

]

/** 與 appendStaticDeviceConfigRoutes、側欄項 id 一致；靜態 main 子路由須帶 meta.menuId 才能 gotoRouteHandle 命中。「模擬機」整組見 {@link hasSimulatorSidebarPermission}。 */
const DEVICE_CONFIG_MENU_IDS = {
  group: 990100,
  profileList: 990101,
  bindings: 990102,
  workbench: 990103,
  coffeeMachineChannels: 990401,
  x600hGateway: 990104,
  simulatorGroup: 990105,
  xt90c2Simulator: 990106,
  blenderSimulator: 990107,
  xosIviSimulator: 990108,
  hansonIviSimulator: 990122,
  teaMachineSimulator: 990126,
  maestroSimulator: 990145,
  storefrontSimulator: 990149,
  deviceLinkDebug: DEVICE_RD_SIDEBAR_MENU_IDS.deviceLinkDebug
}

/** X600H 工厂生产订单（静态侧栏 + 路由；coffee_menu id=990294，勿与 990125 冲突） */
const X600H_PRODUCTION_ORDER_MENU_IDS = {
  list: 990294
}

/** 设备生命周期（报废／僵尸；coffee_menu id=990328–990330） */
const EQUIPMENT_LIFECYCLE_MENU_IDS = {
  page: 990328
}

/** 设备列表（coffee_menu en_name=machineList, id=1721721668100947968） */
const MACHINE_LIST_MENU_IDS = {
  page: 1721721668100947968
}

/** 設備管理一級（coffee_menu en_name=devices） */
const DEVICE_MANAGEMENT_MENU_IDS = {
  group: 1721413909618884608
}

/** 侧栏虚拟一级「设备研发」（990130；聚合调试／模拟机／配置／通信调试／型号修复，仅改 UI 树形） */
const DEVICE_RD_MENU_IDS = DEVICE_RD_SIDEBAR_MENU_IDS

/** 设备调试（coffee_menu 990220；子项 presetCommand / commandConfiguration） */
const MACHINE_DEBUG_MENU_IDS = {
  group: 990220
}

/**
 * DB 歷史根節點（coffee_menu 常見 id）：曾混掛通道 + Profile；087 後僅 Profile 時不再剝離。
 */
const LEGACY_CHANNEL_CONFIG_API_ROOT_ID = 1721413909652439040

/** 通道配置側欄分組（對齊 coffee_menu 990431 · 挂出品管理；勿用 990295） */
const CHANNEL_CONFIG_SIDEBAR_IDS = {
  group: Number(CHANNEL_CONFIG_CATALOG_ID)
}

/** 僅屬「設備配置」990100 的葉節點（勿出現在「通道配置」）— 邏輯見 deviceChannelMenuSplit.js */
const DEVICE_CONFIG_SIDEBAR_LEAF_EN = new Set([
  'configProfileLibrary',
  'configBindDispatch'
])
const DEVICE_CONFIG_SIDEBAR_LEAF_IDS = new Set([
  DEVICE_CONFIG_MENU_IDS.profileList,
  DEVICE_CONFIG_MENU_IDS.bindings,
  DEVICE_CONFIG_MENU_IDS.workbench,
  1900410300000000001,
  1900410300000000002
])

/** 僅屬「通道配置」的葉節點（勿重複在設備配置／出品管理） */
const CHANNEL_CONFIG_SIDEBAR_LEAF_EN = new Set([
  'configDistribute',
  'devicesChannels',
  'channelCategory'
])

/** 产品5 门店客制 POS（A→G）；与 mergeProduceFivePosMenu、静态 main 子路由 meta.menuId 一致 */
const POS_CENTER_MENU_IDS = {
  group: 990285,
  produceFivePos: 990286
}
const PRODUCE_FIVE_POS_MENU_ID = POS_CENTER_MENU_IDS.produceFivePos
/** 旧版注入 id（与 linuxAuto 990240 冲突），迁移时须从侧栏剔除 */
const PRODUCE_FIVE_POS_LEGACY_MENU_ID = 990240

/**
 * 數據中心 · X600H 咖啡機出品／單杯（與 coffee_menu 生產 id 對齊）。
 * 靜態路由用獨立 route name，避免 productionData／singleCupData 與其他機型 enName 衝突。
 */
const DATA_CENTER_COFFEE_MACHINE_MENU_IDS = {
  coffeeData: 1796036995663925248,
  productionData: 1796042739016667136,
  singleCupData: 1904791257176215552
}

/** 數據中心 · 配料機出品／單杯／故障（coffee_menu 東京生產 id） */
const DATA_CENTER_BLEND_MENU_IDS = {
  group: 1904793627641647104,
  productionData: 1904794259333189632,
  singleCupData: 1904794577232072704,
  faultLog: 1904794728583532544
}

/** 出品管理侧栏二级分组（虚拟文件夹；990287–990292 与 POS 990285+ 错开） */
const PRODUCT_CENTER_FOLDER_IDS = {
  basicDict: 990287,
  products: 990288,
  menuDispatch: 990289,
  /** patch 187：与 coffee_menu 990431 channelConfiguration 对齐 */
  channels: Number(CHANNEL_CONFIG_CATALOG_ID),
  addons: 990291,
  other: 990292
}

const PRODUCT_CENTER_FOLDER_EN = new Set([
  'productCenterFolderBasic',
  'productCenterFolderProducts',
  'productCenterFolderMenu',
  'productCenterFolderChannels',
  'channelConfiguration',
  'productCenterFolderAddons',
  'productCenterFolderOther'
])

const PRODUCT_CENTER_FOLDER_META = {
  basicDict: { name: '基礎字典', enName: 'productCenterFolderBasic' },
  products: { name: '品項與配方', enName: 'productCenterFolderProducts' },
  menuDispatch: { name: '菜單與下發', enName: 'productCenterFolderMenu' },
  channels: { name: '通道配置', enName: 'channelConfiguration' },
  addons: { name: '配料與小吃', enName: 'productCenterFolderAddons' },
  other: { name: '其他產品', enName: 'productCenterFolderOther' } // 含稅務產品類型、其他稅務產品等
}

/** 叶子 enName → 分组 key（未命中进 other） */
const PRODUCT_CENTER_LEAF_BUCKET = {
  productCategory: 'basicDict',
  optionCategory: 'basicDict',
  optionList: 'basicDict',
  /** 产品类型（税务计算维度）；展示名见 i18n route.type */
  type: 'other',
  productsList5: 'products',
  productsList2: 'products',
  produceList4: 'products',
  productionList: 'products',
  listOfTeaExtractsProducts: 'products',
  smoothieMakerProduct: 'products',
  coffeeMachineChannelSlots: 'products',
  /** 海外扩展产品列表（extra produce）；展示名见 i18n route.produce */
  produce: 'other',
  otherProducts: 'products',
  additionalProducts: 'products',
  takeoutProducts: 'products',
  storeMenu: 'menuDispatch',
  menuDistribute: 'menuDispatch',
  machineMenu: 'menuDispatch',
  /** patch 187：三叶统一进「通道配置」 */
  channelCategory: 'channels',
  devicesChannels: 'channels',
  configDistribute: 'channels',
  smallMaterial: 'addons',
  accessoriesCategory: 'addons',
  accessoriesList: 'addons'
}

const PRODUCT_CENTER_FOLDER_ORDER = ['basicDict', 'products', 'menuDispatch', 'channels', 'addons', 'other']

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: '/',
  component: _import('layout/Layout'),
  name: 'main',
  redirect: { name: 'login' },
  meta: { title: '' },
  children: [
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    { path: '/home', component: _import('common/home/index'), name: 'home', meta: { title: i18n.t('route.homePage'), isTab: true } },
    { path: '/menu-nav', component: _import('common/menuNav/index'), name: 'menuNav', meta: { title: '選單導航', isTab: true } },
    { path: '/device-detail', component: _import('device/list/detail'), name: 'deviceDetail', meta: { title: i18n.t('route.details'), isTab: true, noCache: true } },
    { path: '/device-detailautomatic', component: _import('device/list/detailAutomatic'), name: 'automaticdeviceDetail', meta: { title: i18n.t('route.details'), isTab: true, noCache: true } },
     { path: '/device-coffee-params', component: _import('device/list/params/coffee/param'), name: 'coffeeMachineParam', meta: { title: i18n.t('route.details'), isTab: true } },
      { path: '/device-coffee-factory-params', component: _import('device/list/params/coffee/factoryParam'), name: 'coffeeMachineFactoryParam', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/device-coffee-module-params', component: _import('device/list/params/coffee/moduleParam'), name: 'coffeeMachineModuleParam', meta: { title: i18n.t('route.details'), isTab: true } },  
    // { path: '/produce-params-detail', component: _import('produce/parameter/detail'), name: 'produceParamsDetail', meta: { title: '出品参数详情', isTab: true } },
    // { path: '/produce-name-detail', component: _import('produce/name/detail'), name: 'produceNameDetail', meta: { title: '出品名称详情', isTab: true } },
     { path: '/produce-name-create', component: _import('produce/nameTwo/create'), name: 'produceNameCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-three-name-create', component: _import('produce/nameThree/create'), name: 'produceThreeNameCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-blender-create', component: _import('produce/blender/create'), name: 'produceBlenderCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-four-name-create', component: _import('produce/nameFour/create'), name: 'produceFourNameCreate', meta: { title: i18n.t('table.add'), isTab: true } },
     { path: '/produce-four-name-copy', component: _import('produce/nameFour/copy'), name: 'produceFourNameCopy', meta: { title: i18n.t('table.copy'), isTab: true } },
    { path: '/produce-name-addProduce', component: _import('produce/name/addProduce'), name: 'addProduce', meta: { title: i18n.t('table.add'), isTab: true } },
    { path: '/produce-name-editProduce', component: _import('produce/name/editProduce'), name: 'editProduce', meta: { title: i18n.t('table.edit'), isTab: true } },
    { path: '/produce-import-detail', component: _import('produce/import/detail'), name: 'produceImportDetail', meta: { title: '菜单下发详情', isTab: true } },
    { path: '/map', component: _import('common/map/index'), name: 'map', meta: { title: i18n.t('route.atlas') } },
    { path: '/merchant-machine', component: _import('merchant/machine/list'), name: 'merchantMachine', meta: { title: i18n.t('route.deviceList') } },
    {
      path: '/device-list-index',
      component: _import('device/list/index'),
      name: 'device-list-index',
      meta: {
        title: i18n.t('route.machineList'),
        isTab: true,
        isDynamic: false,
        menuId: MACHINE_LIST_MENU_IDS.page
      }
    },
    { path: '/device-journal', component: _import('device/list/journal'), name: 'machineJournal', meta: { title: i18n.t('route.journal'), isTab: true } },
    { path: '/device-x600h-production-order', component: _import('device/x600hProductionOrder/index'), name: 'x600hProductionOrder', meta: { title: 'X600H 生产订单', isTab: true, menuId: X600H_PRODUCTION_ORDER_MENU_IDS.list } },
    { path: '/device-x600h-production-order-detail', component: _import('device/x600hProductionOrder/detail'), name: 'x600hProductionOrderDetail', meta: { title: '生产订单详情', isTab: true } },
    { path: '/device-lifecycle', component: _import('device/lifecycle/index'), name: 'equipmentLifecycle', meta: { title: '设备生命周期', isTab: true, menuId: EQUIPMENT_LIFECYCLE_MENU_IDS.page } },
     { path: '/produce-store-product', component: _import('produce/store/product'), name: 'storeProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
     { path: '/produce-machine-product', component: _import('produce/machine/product'), name: 'machineProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
     { path: '/produce-machine-thermoplan-product', component: _import('produce/store/thermoplan/product'), name: 'storeThermoplanProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
     { path: '/produce-thermoplan-machine-product', component: _import('produce/store/thermoplan/machineProduce'), name: 'storeThermoplanMachineProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
    { path: '/dataCenter-machineDataStatistics', component: _import('dataCenter/machineDataStatistics/detail'), name: 'machineDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/system-device-link-debug', component: _import('systemSetting/deviceLinkDebug/index'), name: 'deviceLinkDebug', meta: { title: '设备通信调试', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.deviceLinkDebug } },
    { path: '/dataCenter-x600h-gateway', component: _import('dataCenter/x600hGateway/index'), name: 'x600hGatewayData', meta: { title: 'X600H', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.x600hGateway } },
    { path: '/simulator-xt90c2', component: _import('dataCenter/x600hGateway/index'), name: 'xt90c2Simulator', meta: { title: 'XT90C2 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator } },
    { path: '/simulator-blender', component: _import('simulator/blender/index'), name: 'blenderSimulator', meta: { title: 'Blender 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.blenderSimulator } },
    { path: '/simulator-xos-ivi', component: _import('simulator/xosIvi/index'), name: 'xosIviSimulator', meta: { title: 'XOS 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.xosIviSimulator } },
    { path: '/simulator-hanson-ivi', component: _import('simulator/hansonIvi/index'), name: 'hansonIviSimulator', meta: { title: 'Hansong IVI 模擬機', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator } },
    { path: '/simulator-tea-machine', component: _import('simulator/teaMachine/index'), name: 'teaMachineSimulator', meta: { title: '泡茶机模拟机', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.teaMachineSimulator } },
    { path: '/simulator-maestro', component: _import('simulator/maestro/index'), name: 'maestroSimulator', meta: { title: 'Maestro模拟机', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.maestroSimulator } },
    { path: '/simulator-storefront', component: _import('simulator/storefront/index'), name: 'storefrontSimulator', meta: { title: '点单机Kiosk模拟机', isTab: true, menuId: DEVICE_CONFIG_MENU_IDS.storefrontSimulator } },
    { path: '/machine-bind-chargingBasket', component: _import('chargingBasketManagement/machineChargingBasket/chargingBasketList'), name: 'chargingBasketList', meta: { title: i18n.t('pass.pass'), isTab: true } },
    { path: '/single-product-detail', component: _import('dataCenter/teaDataStatistics/singleDetail'), name: 'singleDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/order-detail', component: _import('image/order/detail'), name: 'orderDetail', meta: { title: i18n.t('route.details'), isTab: true } },
    { path: '/produce-five-pos', redirect: '/image-order-produceFivePos' },
    {
      path: '/image-order-produceFivePos',
      component: _import('image/order/produceFivePos'),
      name: 'image-order-produceFivePos',
      meta: { title: i18n.t('route.produceFivePos'), isTab: true, menuId: PRODUCE_FIVE_POS_MENU_ID }
    },
    { path: '/produce-takeout-addProduce', component: _import('image/delivery/menu/addProduce'), name: 'addTakeoutProduce', meta: { title: i18n.t('table.add'), isTab: true } },
    { path: '/produce-takeout-editProduce', component: _import('image/delivery/menu/editProduce'), name: 'editTakeoutProduce', meta: { title: i18n.t('table.edit'), isTab: true } },
    { path: '/produce-delivery-store-product', component: _import('image/delivery/storeMenu/product'), name: 'uberStoreProduct', meta: { title: i18n.t('business.produce'), isTab: true } },
  
   
   
  ],
  beforeEnter (to, from, next) {
    let token = getToken()
    if (!token || !/\S/.test(token)) {
      clearLoginInfo()
      next({ name: 'login' })
      return
    }
    next()
  }
}

/** 動態選單註冊前快照：避免 fnAddDynamicMenuRoutes 用選單路由覆蓋後「進入平台」找不到 name: home */
const STATIC_MAIN_CHILDREN_SNAPSHOT = mainRoutes.children.slice()

/** axios / request 攔截器對任意 code!==200 皆 reject；僅 401 應導向登出，其餘錯誤須放行導航並勿清 token */
function isRouterAuthFailure (err) {
  if (!err) return false
  if (err.code === 401) return true
  if (err.response && err.response.status === 401) return true
  return false
}

const router =new Router({
   mode: 'hash',
   scrollBehavior: () => ({ y: 0 }),
   isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
   routes: globalRoutes.concat(mainRoutes)
})

/**
 * 以新路由表替換 matcher。僅 addRoute 疊加、且 removeRoute 未實作或未清空 nameMap 時，
 * 會對子路由名稱（如 home）重複註冊而觸發 Duplicate named routes。
 * 參考 vue-element-admin resetRouter：整表替換最穩。
 */
function replaceRouterMatcher (routes) {
  const opts = router.options
  const next = new Router({
    mode: opts.mode || 'hash',
    scrollBehavior: opts.scrollBehavior,
    isAddDynamicMenuRoutes: opts.isAddDynamicMenuRoutes,
    routes: routes
  })
  router.matcher = next.matcher
}

function readNavRawFromSession () {
  try {
    const raw = sessionStorage.getItem('menuApiRaw')
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

/** 路由守卫 SSOT：nav 已含该 enName 时不再用 session permissions 二次拦截 */
function navRawContainsEnName (enName) {
  if (!enName) return false
  return menuTreeContainsEnName(readNavRawFromSession(), enName)
}

function navRawContainsMenuId (menuId) {
  if (menuId == null || menuId === '') return false
  return menuTreeContainsNodeId(readNavRawFromSession(), menuId)
}

router.beforeEach((to, from, next) => {
  if (to && (to.name === 'deviceLinkDebug' || to.name === 'x600hGatewayData' || to.name === 'xt90c2Simulator' || to.name === 'blenderSimulator' || to.name === 'xosIviSimulator' || to.name === 'hansonIviSimulator' || to.name === 'teaMachineSimulator' || to.name === 'maestroSimulator' || to.name === 'storefrontSimulator') && !hasSimulatorSidebarPermission()) {
    next({ name: 'home', replace: true })
    return
  }
  const routePathKey = String(to.path || '').replace(/^\//, '').replace(/\//g, '-')
  if (to && (
    (to.name && String(to.name).indexOf('memberHq') === 0) ||
    routePathKey.indexOf('member-hq-') === 0 ||
    routePathKey.indexOf('hq-member-') === 0
  ) && !navRawContainsEnName('memberHqGroup') && !navRawContainsEnName('memberHqDashboard') && !canAccessMemberHqGroupMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    (to.name && String(to.name).indexOf('distributor') === 0) ||
    routePathKey.indexOf('distributor-') === 0
  ) && !navRawContainsEnName('distributorReportGroup') && !navRawContainsEnName('distributorDashboard') && !canAccessDistributorReportMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    routePathKey.indexOf('linuxAuto-') === 0 ||
    routePathKey.indexOf('ivi-can-onboarding') === 0 ||
    to.name === 'leoInCarHub'
  ) && !navRawContainsEnName('linuxAutoOps') && !canAccessLinuxAutoOpsMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    to.name === 'x600hProductionOrder' ||
    to.name === 'x600hProductionOrderDetail' ||
    routePathKey.indexOf('device-x600h-production-order') === 0
  ) && !navRawContainsEnName('x600hProductionOrder') && !canAccessX600hProductionOrderMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    to.name === 'deviceConfig-coffeeMachineChannels' ||
    routePathKey.indexOf('deviceConfig-coffeeMachineChannels') === 0 ||
    routePathKey.indexOf('device-config-coffee-machine-channels') === 0
  ) && !canAccessCoffeeMachineRecipeCenterMenu()) {
    next({ name: 'home', replace: true })
    return
  }
  if (to && (
    (to.name && String(to.name).indexOf('support-ticket') === 0) ||
    routePathKey.indexOf('support-ticket') === 0
  )) {
    const isCreate = to.name === 'support-ticket-create' || to.name === 'support-ticket-h5'
    const isMine = to.name === 'support-ticket-mine'
    const isWorkbench = to.name === 'support-ticket-workbench'
    if (isCreate && !navRawContainsEnName('supportTicketCreate') && !canAccessSupportTicketCreate()) {
      next({ name: 'home', replace: true })
      return
    }
    if (isMine && !navRawContainsEnName('supportTicketMine') && !canAccessSupportTicketMine()) {
      next({ name: 'home', replace: true })
      return
    }
    if (isWorkbench && !navRawContainsEnName('supportTicketWorkbench') && !canAccessSupportTicketWorkbench()) {
      next({ name: 'home', replace: true })
      return
    }
  }
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
    if (router.options.isAddDynamicMenuRoutes) {
      reconcileSidebarMenuSsotFromSession()
    }
    const leoAny = to.meta && to.meta.leoKnowledgeAnyOf
    const leoReq = to.meta && to.meta.leoKnowledgePermission
    if (leoAny && Array.isArray(leoAny) && leoAny.length > 0) {
      const ok = leoAny.some((c) => hasPermission(c))
      if (!ok) {
        next({ name: 'home', replace: true })
        return
      }
    } else if (leoReq && !hasPermission(leoReq)) {
      next({ name: 'home', replace: true })
      return
    }
    next()
  } else {
    permissionApi()
      .catch((permErr) => {
        if (isRouterAuthFailure(permErr)) {
          return Promise.reject(permErr)
        }
        sessionStorage.setItem('permissions', '[]')
        return { code: 200, data: [] }
      })
      .then((permRes) => {
        if (permRes && permRes.code === 200) {
          sessionStorage.setItem('permissions', JSON.stringify(permRes.data || '[]'))
        } else {
          sessionStorage.setItem('permissions', '[]')
        }
        return menuApi()
      })
      .then((res) => {
        if (res && res.code === 200) {
          const rawMenus = res.data || []
          sessionStorage.setItem('menuApiRaw', JSON.stringify(rawMenus))
          const sidebarMenus = mergeDeviceConfigSidebarMenus(rawMenus)
          fnAddDynamicMenuRoutes(sidebarMenus)
          router.options.isAddDynamicMenuRoutes = true
          sessionStorage.setItem('menuList', JSON.stringify(sidebarMenus))
          store.commit('common/updateMenuList', sidebarMenus)
          next({ ...to, replace: true })
          return
        }
        sessionStorage.setItem('menuList', '[]')
        sessionStorage.setItem('permissions', '[]')
        if (to && to.name === 'home' && getToken() && /\S/.test(String(getToken()))) {
          applyEmptyDynamicMenuFallback()
        }
        next()
      })
      .catch((e) => {
        if (isRouterAuthFailure(e)) {
          store.dispatch('FedLogOut').then(() => {
            clearLoginInfo()
            removeToken()
            next({ name: 'login', replace: true })
          })
          return
        }
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('[router] menu/permission 非 401 錯誤，中止本次導航並保留登入狀態：', e && e.message ? e.message : e)
        }
        sessionStorage.setItem('permissions', '[]')
        // 登入後先到 /dataShow 再進入 home 時，menu/permission 常易失敗；不應靜默 next(false) 致「进入平台」無反應
        if (to && to.name === 'home' && getToken() && /\S/.test(String(getToken()))) {
          applyEmptyDynamicMenuFallback()
          next({ name: 'home', replace: true })
        } else {
          next(false)
        }
      })
  }
})

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
  if (route.path === '/leo' || route.path.startsWith('/leo/')) {
    return 'global'
  }
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

function isTrainingLakeHost () {
  return String(process.env.VUE_APP_TRAINING_LAKE_HOST || '').toLowerCase() === 'true'
}

/** 側欄靜態合併會重建 Leo 樹；仅 strip LEO_SIDEBAR_REBUILD（见 sidebarMenuIdSsot.js）。 */
const LEO_SIDEBAR_STRIP_IDS = buildLeoSidebarStripIdSet()
const LEO_SIDEBAR_STRIP_EN = new Set([
  'leoKnowledgeGroup',
  'leoKnowledgePortalHub',
  'leoKnowledgeUiSurfaceSample',
  'leoKnowledgeModelFields',
  'leoKnowledgeEquipmentTypeTypeKey',
  'leoKnowledgeUpload',
  'leoKnowledgeIngestBatch',
  'leoKnowledgePhase1Ssot',
  'leoKnowledgeCapabilityMatrix',
  'leoKnowledgeOnboarding',
  'leoKnowledgeTesterConsole',
  'leoKnowledgePipelineHub',
  'leoKnowledgeFeatureSurface',
  'leoKnowledgeProtocolDoc',
  'leoKnowledgeRemoteTools',
  'leoKnowledgeLearning',
  'leoKnowledgeExternalIngest',
  'leoDeviceOpsRolePolicy',
  'leoDeviceOpsSemanticTraining',
  'leoProductionE2eTraining',
  'leoTrainingDashboard',
  'leoT2GoldenTraining',
  'leoT9DeepseekTraining',
  'leoTurnRoutingTrainingHub',
  'leoKnowledgePortalOpsInventory',
  'leoKnowledgePortalOpsDailyHub',
  'leoDeviceOpsReviewInbox',
  'leoDeviceOpsDescriptionAutogen',
  'leoDeviceOpsBLineDailyHub',
  'leoCommandOnboardingWizard',
  'leoXeeGrowthDashboard',
  'leoTasteHabitPerception'
])

function findMenuNodeById (nodes, id) {
  if (!Array.isArray(nodes) || id == null) return null
  const want = Number(id)
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Number(n.id) === want) return n
    const hit = findMenuNodeById(n.menuList, id)
    if (hit) return hit
  }
  return null
}

function menuTreeContainsNodeId (nodes, id) {
  return !!findMenuNodeById(nodes, id)
}

/** 會員 HQ × 分銷商報表（與 patch 080/082 coffee_menu 對齊；勿與 LEO 990271/272 混用） */
const MEMBER_HQ_MENU_IDS = {
  group: 990285,
  dashboard: 990273,
  list: 990273,
  detail: 990305,
  finance: 990274,
  ops: 990275,
  umMemberAdmin: 990406,
  distGroup: 990280,
  distDashboard: 990281,
  distMembers: 990282,
  distProfit: 990283
}

/** 商家 Token 帳單平台（與 DB patch 029、views/accountManagement/tokenBillingPlatform 對齊） */
const MERCHANT_TOKEN_BILLING_PLATFORM_MENU_ID = 990231
const MERCHANT_DATA_BILLING_PLATFORM_MENU_ID = 990232

function findDevicesSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (
      Number(n.id) === DEVICE_MANAGEMENT_MENU_IDS.group ||
      en === 'devices' ||
      en === 'device' ||
      name === '设备管理' ||
      name === '設備管理' ||
      name === '设备'
    ) {
      return n
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findDevicesSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function findProductCenterSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (name === '出品管理' || en === 'productCenter') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findProductCenterSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function findBusinessCenterSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (name === '业务中心' || name === '業務中心' || en === 'businessCenter') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findBusinessCenterSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function stripProduceFivePosLegacyPlacements (nodes) {
  if (!Array.isArray(nodes)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    const isLegacyLeaf = (Number(n.id) === PRODUCE_FIVE_POS_LEGACY_MENU_ID ||
      (n.enName === 'produceFivePos' && Number(n.id) !== PRODUCE_FIVE_POS_MENU_ID))
    const isPosGroup = Number(n.id) === POS_CENTER_MENU_IDS.group
    if (isLegacyLeaf && !isPosGroup) {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      stripProduceFivePosLegacyPlacements(n.menuList)
    }
  }
  const productCenter = findProductCenterSidebarParent(nodes)
  if (productCenter && Array.isArray(productCenter.menuList)) {
    productCenter.menuList = productCenter.menuList.filter((x) => {
      if (!x) return false
      if (x.enName === 'produceFivePos') return false
      if (Number(x.id) === PRODUCE_FIVE_POS_LEGACY_MENU_ID) return false
      if (Number(x.id) === PRODUCE_FIVE_POS_MENU_ID) return false
      return true
    })
  }
}

function upsertDataCenterCoffeeMachineLeaf (menuList, leaf) {
  if (!Array.isArray(menuList) || !leaf) return
  const idx = menuList.findIndex(
    (x) =>
      x &&
      (Number(x.id) === Number(leaf.id) ||
        (leaf.enName && menuNodeEnName(x) === leaf.enName))
  )
  if (idx >= 0) {
    menuList[idx] = Object.assign({}, menuList[idx], leaf)
  } else {
    menuList.push(leaf)
  }
}

/** 後端 nav 已授權「咖啡机数据」分支時才合併（萃茶机等其它机型也复用 singleCupData/productionData enName，不可仅凭 enName 触发） */
function apiMenuTreeContainsDataCenterCoffeeMachineMerge (raw) {
  if (!Array.isArray(raw) || !raw.length) return false
  const ids = DATA_CENTER_COFFEE_MACHINE_MENU_IDS
  if (menuTreeContainsEnName(raw, 'coffeeData')) return true
  return (
    menuTreeContainsNodeId(raw, ids.coffeeData) ||
    menuTreeContainsNodeId(raw, ids.productionData) ||
    menuTreeContainsNodeId(raw, ids.singleCupData)
  )
}

/** X600H 咖啡機：數據中心下「出品數據」「單杯數據」側欄（頁面已實作於 machineDataStatistics） */
function mergeDataCenterCoffeeMachineMenus (list, rawApiMenus) {
  if (!apiMenuTreeContainsDataCenterCoffeeMachineMerge(rawApiMenus)) return
  const dc = findDataCenterSidebarParent(list)
  if (!dc) return
  if (!Array.isArray(dc.menuList)) dc.menuList = []

  const productionLeaf = {
    id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.productionData,
    name: '出品数据',
    enName: 'productionData',
    url: 'dataCenter/machineDataStatistics/productStatistics',
    icon: 'list'
  }
  const singleCupLeaf = {
    id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.singleCupData,
    name: '单杯数据',
    enName: 'singleCupData',
    url: 'dataCenter/machineDataStatistics/singleProductStatistics',
    icon: 'maintain'
  }

  const groupId = DATA_CENTER_COFFEE_MACHINE_MENU_IDS.coffeeData
  let group = dc.menuList.find(
    (x) => x && (Number(x.id) === groupId || menuNodeEnName(x) === 'coffeeData')
  )
  if (!group) {
    dc.menuList.push({
      id: groupId,
      name: '咖啡机数据',
      enName: 'coffeeData',
      icon: 'paper-cup',
      menuList: [productionLeaf, singleCupLeaf]
    })
    return
  }
  if (!Array.isArray(group.menuList)) group.menuList = []
  upsertDataCenterCoffeeMachineLeaf(group.menuList, productionLeaf)
  upsertDataCenterCoffeeMachineLeaf(group.menuList, singleCupLeaf)
}

function mergeProduceFivePosMenu (list) {
  // 不在此處校驗 produce:*：merge 早於 permissionApi，首登 session 尚無 *:*:* 會誤判。
  stripProduceFivePosLegacyPlacements(list)
  const business = findBusinessCenterSidebarParent(list)
  if (!business || !Array.isArray(business.menuList)) return
  const leaf = {
    id: PRODUCE_FIVE_POS_MENU_ID,
    name: '产品5门店客制',
    enName: 'produceFivePos',
    url: 'image/order/produceFivePos',
    icon: 'shopping'
  }
  let group = business.menuList.find((x) => x && Number(x.id) === POS_CENTER_MENU_IDS.group)
  if (!group) {
    business.menuList.push({
      id: POS_CENTER_MENU_IDS.group,
      name: 'POS中心',
      enName: 'posCenter',
      icon: 'shopping',
      menuList: [leaf]
    })
    return
  }
  if (!Array.isArray(group.menuList)) group.menuList = []
  const idx = group.menuList.findIndex((x) => x && (Number(x.id) === PRODUCE_FIVE_POS_MENU_ID || x.enName === 'produceFivePos'))
  if (idx >= 0) group.menuList[idx] = leaf
  else group.menuList.push(leaf)
}

function flattenProductCenterMenuItems (items) {
  const out = []
  if (!Array.isArray(items)) return out
  for (let i = 0; i < items.length; i++) {
    const n = items[i]
    if (!n) continue
    const en = n.enName != null ? String(n.enName).trim() : ''
    const children = Array.isArray(n.menuList) ? n.menuList : []
    const hasUrl = n.url != null && /\S/.test(String(n.url))
    if (children.length && (PRODUCT_CENTER_FOLDER_EN.has(en) || !hasUrl)) {
      const nested = flattenProductCenterMenuItems(children)
      for (let j = 0; j < nested.length; j++) out.push(nested[j])
    } else {
      out.push(n)
    }
  }
  return out
}

function buildProductCenterSidebarTree (leaves) {
  const buckets = {
    basicDict: [],
    products: [],
    menuDispatch: [],
    channels: [],
    addons: [],
    other: []
  }
  for (let i = 0; i < leaves.length; i++) {
    const leaf = leaves[i]
    if (!leaf) continue
    const en = leaf.enName != null ? String(leaf.enName).trim() : ''
    if (en === 'produceFivePos') continue
    const key = PRODUCT_CENTER_LEAF_BUCKET[en] || 'other'
    buckets[key].push(leaf)
  }
  const groups = []
  for (let f = 0; f < PRODUCT_CENTER_FOLDER_ORDER.length; f++) {
    const key = PRODUCT_CENTER_FOLDER_ORDER[f]
    const items = buckets[key]
    if (!items || !items.length) continue
    const meta = PRODUCT_CENTER_FOLDER_META[key]
    const folder = leoSidebarFolder(
      PRODUCT_CENTER_FOLDER_IDS[key],
      meta.name,
      meta.enName,
      items
    )
    if (folder) groups.push(folder)
  }
  return groups
}

/** 出品管理：API 平铺叶子 → 五组二级树（不改叶子 menuId／url） */
function mergeProductCenterSidebarTree (list) {
  const productCenter = findProductCenterSidebarParent(list)
  if (!productCenter || !Array.isArray(productCenter.menuList)) return
  const leaves = flattenProductCenterMenuItems(productCenter.menuList)
  if (!leaves.length) return
  const grouped = buildProductCenterSidebarTree(leaves)
  if (!grouped.length) return
  productCenter.menuList = grouped
}

function detachTopLevelMenuById (list, id) {
  if (!Array.isArray(list) || id == null) return null
  const idx = list.findIndex((n) => n && Number(n.id) === Number(id))
  if (idx < 0) return null
  const node = list[idx]
  list.splice(idx, 1)
  return node
}

/** 售后服务：990320/990350/运维管理 收拢到 990380（DB patch 122 未跑时侧栏兜底；已有根也要收齐缺子） */
function mergeAfterSalesServiceSidebarMenu (list) {
  if (!Array.isArray(list)) return
  const rootId = AFTER_SALES_SERVICE_MENU_IDS.root
  const childIds = [
    AFTER_SALES_SERVICE_MENU_IDS.maintenanceGroup,
    AFTER_SALES_SERVICE_MENU_IDS.supportTicketGroup,
    AFTER_SALES_SERVICE_MENU_IDS.deviceServiceGroup
  ]
  const existingRoot = findMenuNodeById(list, rootId)
  const collected = []
  childIds.forEach((cid) => {
    const node = detachTopLevelMenuById(list, cid)
    if (node) collected.push(node)
  })
  if (!collected.length && !existingRoot) return
  let root = existingRoot || detachTopLevelMenuById(list, rootId)
  if (!root) {
    root = {
      id: rootId,
      name: '售后服务',
      enName: 'afterSalesServiceGroup',
      icon: 'service'
    }
  }
  if (!Array.isArray(root.menuList)) root.menuList = []
  collected.forEach((node) => {
    if (!root.menuList.some((n) => n && Number(n.id) === Number(node.id))) {
      root.menuList.push(node)
    }
  })
  if (!root.menuList.length) return
  root.menuList.sort((a, b) => Number(a.id) - Number(b.id))
  if (!findMenuNodeById(list, rootId)) list.push(root)
}

function findAccountSettingsSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const name = String(n.name || '')
    const en = String(n.enName || '').trim()
    if (name === '账号设置' || name === '帳號設置' || name === '帐号设置') return n
    if (en === 'accountSetting' || en === 'accountSettings') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findAccountSettingsSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function findLoginAccountSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    const en = String(n.enName || '').trim()
    if (en === 'loginAccount') return n
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findLoginAccountSidebarParent(n.menuList)
      if (hit) return hit
    }
  }
  return null
}

function hasAnyPermission (codes) {
  if (!Array.isArray(codes) || !codes.length) return false
  return codes.some((c) => hasPermission(c))
}

/** 與 coffee_menu perms（patch 079）對齊 */
function canAccessMemberHqGroupMenu () {
  return hasPermission('hq:member:view')
}

function canAccessLeoUmMemberAdminMenu () {
  return hasPermission('leo:um:member:view')
}

/** 與 coffee_menu perms（patch 079）對齊 */
function canAccessDistributorReportMenu () {
  return hasPermission('distributor:report:read')
}

/** 與 registerLeoInCarStaffRoutes 對齊（leo:knowledge:view|upload） */
function canAccessLinuxAutoOpsMenu () {
  return hasAnyPermission([LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD])
}

/** 與 coffee_menu 990231 / patch 079 對齊 */
function canAccessMerchantTokenBillingMenu () {
  return hasPermission('merchant:token:billing:view')
}

/** 與 coffee_menu 990232 / patch 079 對齊 */
function canAccessMerchantDataBillingMenu () {
  return hasPermission('merchant:data:billing:view')
}

/** 与 coffee_menu 990294 / SaToken x600h:production-order:* 对齐；勿用 device:add 泛化 */
function canAccessX600hProductionOrderMenu () {
  return hasPermission('x600h:production-order:view') ||
    hasPermission('x600h:production-order:edit')
}

/** X600H 配方中心（coffee_menu 990401）：僅認後端 nav／role_menu，禁止用 device:edit 泛化 */
function canAccessCoffeeMachineRecipeCenterMenu () {
  return navRawContainsEnName('coffeeMachineChannelSlots') ||
    navRawContainsMenuId(DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels)
}

/** 設備配置靜態合併：僅當 menuApi 已含 deviceConfig 綁定時保留 */
function apiMenuTreeContainsDeviceConfigRoot (raw) {
  if (!Array.isArray(raw) || !raw.length) return false
  if (menuTreeContainsNodeId(raw, DEVICE_CONFIG_MENU_IDS.group)) return true
  if (menuTreeContainsEnName(raw, 'deviceConfig')) return true
  function walk (list) {
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n) continue
      if (isLegacyApiDeviceConfigRoot(n)) return true
      if (Array.isArray(n.menuList) && n.menuList.length && walk(n.menuList)) return true
    }
    return false
  }
  return walk(raw)
}

/** 模擬機靜態合併：僅當 nav 已含模擬器相關綁定 */
function apiMenuTreeContainsSimulatorMerge (raw) {
  if (!Array.isArray(raw) || !raw.length) return false
  if (menuTreeContainsNodeId(raw, DEVICE_CONFIG_MENU_IDS.simulatorGroup)) return true
  const ens = ['simulatorGroup', 'x600hGateway', 'xt90c2Simulator', 'blenderSimulator', 'teaMachineSimulator', 'maestroSimulator', 'storefrontSimulator', 'deviceSimulatorConsole']
  for (let i = 0; i < ens.length; i++) {
    if (menuTreeContainsEnName(raw, ens[i])) return true
  }
  return false
}

function pruneUnauthorizedDeviceConfigSidebar (nodes, rawApiMenus) {
  if (!Array.isArray(nodes)) return
  if (apiMenuTreeContainsDeviceConfigRoot(rawApiMenus)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) continue
    const id = Number(n.id)
    const en = menuNodeEnName(n)
    if (id === DEVICE_CONFIG_MENU_IDS.group || en === 'deviceConfig') {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      pruneUnauthorizedDeviceConfigSidebar(n.menuList, rawApiMenus)
    }
  }
}

function pruneUnauthorizedInjectedSidebarMenus (nodes, navAuthorizedIds) {
  if (!Array.isArray(nodes)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    if (isNavAuthorizedMenuId(n.id, navAuthorizedIds)) {
      if (Array.isArray(n.menuList) && n.menuList.length) {
        pruneUnauthorizedInjectedSidebarMenus(n.menuList, navAuthorizedIds)
      }
      continue
    }
    const id = Number(n.id)
    const en = n.enName != null ? String(n.enName).trim() : ''
    if (id === MEMBER_HQ_MENU_IDS.group && !canAccessMemberHqGroupMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if (id === MEMBER_HQ_MENU_IDS.distGroup && !canAccessDistributorReportMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if (id === LINUX_AUTO_MENU_IDS.group && !canAccessLinuxAutoOpsMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if ((id === X600H_PRODUCTION_ORDER_MENU_IDS.list || en === 'x600hProductionOrder') &&
      !canAccessX600hProductionOrderMenu()) {
      nodes.splice(i, 1)
      continue
    }
    if ((id === DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels || en === 'coffeeMachineChannelSlots') &&
      !canAccessCoffeeMachineRecipeCenterMenu()) {
      nodes.splice(i, 1)
      continue
    }
    const coffeeDcIds = DATA_CENTER_COFFEE_MACHINE_MENU_IDS
    if (
      (id === coffeeDcIds.coffeeData || id === coffeeDcIds.productionData || id === coffeeDcIds.singleCupData ||
        en === 'coffeeData') &&
      !isNavAuthorizedMenuId(id, navAuthorizedIds)
    ) {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      pruneUnauthorizedInjectedSidebarMenus(n.menuList, navAuthorizedIds)
      if (!n.menuList.length && !/\S/.test(String(n.url || ''))) {
        nodes.splice(i, 1)
      }
    }
  }
}

function buildSidebarRbacEnChecks () {
  return {
    memberHqGroup: () => canAccessMemberHqGroupMenu(),
    memberHqDashboard: () => canAccessMemberHqGroupMenu(),
    memberHqFinance: () => canAccessMemberHqGroupMenu(),
    memberHqOps: () => canAccessMemberHqGroupMenu(),
    leoUmMemberAdmin: () => canAccessLeoUmMemberAdminMenu(),
    distributorReportGroup: () => canAccessDistributorReportMenu(),
    distributorDashboard: () => canAccessDistributorReportMenu(),
    distributorMembers: () => canAccessDistributorReportMenu(),
    distributorProfit: () => canAccessDistributorReportMenu(),
    linuxAutoOps: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoEquipment: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoRemoteOps: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoProfileConfig: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoDataBilling: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoModelRegistry: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoPartnerDelivery: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoFleetMonitor: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoDbcEntitlement: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoCabinFeatures: () => canAccessLinuxAutoOpsMenu(),
    linuxAutoCanAutoMatch: () => canAccessLinuxAutoOpsMenu(),
    x600hProductionOrder: () => canAccessX600hProductionOrderMenu(),
    coffeeMachineChannelSlots: () => canAccessCoffeeMachineRecipeCenterMenu()
  }
}

function applySidebarRbacFilter (list, rawApiMenus) {
  const navIds = collectNavMenuIds(rawApiMenus)
  stripUnassignedRbacSidebarMenus(list, rawApiMenus)
  pruneSidebarNodesByEnChecks(list, buildSidebarRbacEnChecks(), navIds)
  pruneUnauthorizedDeviceConfigSidebar(list, rawApiMenus)
  pruneUnauthorizedInjectedSidebarMenus(list, navIds)
}

/** 會員 HQ／渠道：僅依後端 nav + 角色授權，禁止前端硬注入（见 sidebarPermissionFilter） */
function mergeMemberHqMenu (_list) {
  /* no-op */
}

function mergeMerchantTokenBillingPlatformMenu (_list) {
  /* no-op — 990231 由 coffee_menu + role_menu 控制 */
}

function mergeMerchantDataBillingPlatformMenu (_list) {
  /* no-op — 990232 由 coffee_menu + role_menu 控制 */
}

/** 車載運營：僅依後端 nav + leo:knowledge 權限，禁止前端硬注入 */
function mergeLinuxAutoOpsMenu (_list) {
  /* no-op */
}

/** 與後台 Sa-Token（Leo／product onboarding）一致，供 meta.leoKnowledgePermission 與側欄過濾 */
const LEO_KNOWLEDGE_PERM_CODES = {
  VIEW: 'leo:knowledge:view',
  UPLOAD: 'leo:knowledge:upload'
}

function getPermissionsFromSession () {
  try {
    const raw = sessionStorage.getItem('permissions')
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

function hasPermission (code) {
  if (!code) return true
  const perms = getPermissionsFromSession()
  return perms.includes(code) || perms.includes('*:*:*')
}

/** Leo 侧栏：API nav 已含 leoKnowledgeGroup 或平台 admin 时须重建树（strip 后不能仅靠 session permissions）。 */
function resolveLeoKnowledgeSidebarGates (rawApiMenus) {
  const raw = Array.isArray(rawApiMenus) ? rawApiMenus : []
  const navHasLeoKnowledge = menuTreeContainsEnName(raw, 'leoKnowledgeGroup')
  const isPlatformAdmin = isPlatformAdminFromStore(store)
  const leoView = hasPermission(LEO_KNOWLEDGE_PERM_CODES.VIEW) || navHasLeoKnowledge || isPlatformAdmin
  const leoUpload = hasPermission(LEO_KNOWLEDGE_PERM_CODES.UPLOAD) || isPlatformAdmin
  return { leoView, leoUpload }
}

/** 側欄「模擬機」整組（X600H + XT90C2）；優先 granting {@code device:simulator:view}（DB 見 patch 020）。仍接受舊碼 {@code x600h:gateway:view}。 */
function hasSimulatorSidebarPermission () {
  return hasPermission('device:simulator:view') || hasPermission('x600h:gateway:view')
}

function hasAdministratorSidebarPermission () {
  return hasPermission('administrator:add') || hasPermission('administrator:edit')
}

/**
 * menuApi 會帶入 coffee_menu 中的模擬器樹（patch 020／134：990105 等），與本檔靜態
 * {@link buildSimulatorGroupSidebarNode} 重複時僅剔除 **不在「设备研发」下** 的影子節點。
 * patch 134 起模擬機子葉跟 DB；側欄不得清空 deviceRd 下的 simulatorGroup。
 */
function stripShadowedSimulatorMenusFromApi (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  const stripIds = new Set([
    DEVICE_CONFIG_MENU_IDS.x600hGateway,
    DEVICE_CONFIG_MENU_IDS.simulatorGroup,
    DEVICE_CONFIG_MENU_IDS.xt90c2Simulator,
    DEVICE_CONFIG_MENU_IDS.blenderSimulator,
    DEVICE_CONFIG_MENU_IDS.xosIviSimulator,
    DEVICE_CONFIG_MENU_IDS.hansonIviSimulator,
    DEVICE_CONFIG_MENU_IDS.teaMachineSimulator,
    DEVICE_CONFIG_MENU_IDS.maestroSimulator,
    DEVICE_CONFIG_MENU_IDS.storefrontSimulator
  ])
  const stripEn = new Set(['simulatorGroup', 'x600hGateway', 'xt90c2Simulator', 'blenderSimulator', 'xosIviSimulator', 'hansonIviSimulator', 'teaMachineSimulator', 'maestroSimulator', 'storefrontSimulator', 'deviceSimulatorConsole'])
  function walk (list, parentId, parentEn) {
    const out = []
    const underDeviceRd =
      Number(parentId) === DEVICE_RD_MENU_IDS.group || parentEn === 'deviceRdGroup'
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n || n.id == null) continue
      const en = menuNodeEnName(n)
      if (!underDeviceRd) {
        if (stripIds.has(Number(n.id))) continue
        if (en && stripEn.has(en)) continue
      }
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList, Number(n.id), en)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes, 0, '')
}

/**
 * menuApi 已含 patch 035 之 Leo 分組與頁面；{@link mergeDeviceConfigSidebarMenus} 再以靜態樹合併，
 * 若不剔除會出現兩個「Leo 知識庫」及同 id 子項重複。與模擬器 {@link stripShadowedSimulatorMenusFromApi} 同型。
 */
function menuNodeNumericId (n) {
  if (!n || n.id == null || n.id === '') return null
  const num = Number(n.id)
  return Number.isFinite(num) ? num : null
}

function stripShadowedLeoKnowledgeMenusFromApi (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n || n.id == null) continue
      const nid = menuNodeNumericId(n)
      if (nid != null && LEO_SIDEBAR_STRIP_IDS.has(nid)) continue
      const en = n.enName != null ? String(n.enName) : ''
      if (en && LEO_SIDEBAR_STRIP_EN.has(en)) continue
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes)
}

/** 舊版車載 id（990240–990249、990270 CAN 匹配）與 Leo／會員 HQ 衝突；以靜態 990300+ 為準，自 API 樹剔除。 */
const LINUX_AUTO_SIDEBAR_STRIP_EN = new Set([
  'linuxAutoOps',
  'linuxAutoEquipment',
  'linuxAutoRemoteOps',
  'linuxAutoProfileConfig',
  'linuxAutoDataBilling',
  'linuxAutoModelRegistry',
  'linuxAutoPartnerDelivery',
  'linuxAutoFleetMonitor',
  'linuxAutoDbcEntitlement',
  'linuxAutoCabinFeatures',
  'linuxAutoCanAutoMatch'
])

function stripShadowedLinuxAutoMenusFromApi (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  const keepMin = LINUX_AUTO_MENU_IDS.group
  const keepMax = LINUX_AUTO_MENU_IDS.canAutoMatch
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n || n.id == null) continue
      const en = n.enName != null ? String(n.enName).trim() : ''
      const id = Number(n.id)
      if (en && LINUX_AUTO_SIDEBAR_STRIP_EN.has(en) && !(id >= keepMin && id <= keepMax)) {
        continue
      }
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes)
}

function leoSidebarLeaf (id, name, enName, icon) {
  const item = { id, name, enName, icon: icon || '' }
  return item
}

function leoSidebarFolder (id, name, enName, children, icon) {
  const menuList = (children || []).filter(Boolean)
  if (!menuList.length) return null
  return { id, name, enName, icon: icon || 'nested', menuList }
}

/** Leo 知识库侧栏：一级分组 + 二级功能页（menuId／路由不变） */
function buildLeoKnowledgeSidebarTree (leoView, leoUpload) {
  const groups = []

  const portalLeaves = [
    leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.portalHub, 'Leo 對話與營運', 'leoKnowledgePortalHub')
  ]
  if (leoView) {
    portalLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.pipelineHub, '管線總覽', 'leoKnowledgePipelineHub'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.testerConsole, '測試員主控台', 'leoKnowledgeTesterConsole')
    )
  }
  if (leoUpload) {
    portalLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard, 'XEE · Leo 成長', 'leoXeeGrowthDashboard')
    )
  }
  const portalFolder = leoSidebarFolder(
    LEO_SIDEBAR_FOLDER_IDS.portalOverview,
    '門戶與總覽',
    'leoKnowledgeFolderPortal',
    portalLeaves,
    'leo-folder-portal'
  )
  if (portalFolder) groups.push(portalFolder)

  if (leoView) {
    const modelFolder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.modelKnowledge,
      '型號與知識',
      'leoKnowledgeFolderModel',
      [
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.modelFields, '型號知識欄位', 'leoKnowledgeModelFields'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.equipmentTypeTypeKey, '設備類型 type_key', 'leoKnowledgeEquipmentTypeTypeKey'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.capabilityMatrix, '能力矩陣', 'leoKnowledgeCapabilityMatrix'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.onboarding, '智慧型號引導', 'leoKnowledgeOnboarding')
      ],
      'leo-folder-model'
    )
    if (modelFolder) groups.push(modelFolder)
  }

  const ingestLeaves = []
  if (leoUpload) {
    ingestLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.upload, '知識上傳', 'leoKnowledgeUpload'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.ingestBatch, '入庫批次（自動建立）', 'leoKnowledgeIngestBatch'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.phase1Ssot, 'Phase1 SSOT 管線', 'leoKnowledgePhase1Ssot')
    )
  }
  if (leoView) {
    ingestLeaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.learning, '學習閉環', 'leoKnowledgeLearning'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.externalIngest, '外部知識入庫', 'leoKnowledgeExternalIngest')
    )
  }
  const ingestFolder = leoSidebarFolder(
    LEO_SIDEBAR_FOLDER_IDS.ingestLoop,
    '入庫與閉環',
    'leoKnowledgeFolderIngest',
    ingestLeaves,
    'leo-folder-ingest'
  )
  if (ingestFolder) groups.push(ingestFolder)

  if (leoView) {
    const protocolFolder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.protocolTools,
      '協議與工具',
      'leoKnowledgeFolderProtocol',
      [
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.featureSurface, '功能→API 映射', 'leoKnowledgeFeatureSurface'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.protocolDoc, '協議文檔索引', 'leoKnowledgeProtocolDoc'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.remoteTool, '遙控工具目錄', 'leoKnowledgeRemoteTools')
      ],
      'leo-folder-protocol'
    )
    if (protocolFolder) groups.push(protocolFolder)
  }

  if (leoView || leoUpload) {
    const opsLeaves = []
    if (leoUpload) {
      opsLeaves.push(
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk, '训练决策台', 'leoTrainingDecisionDesk'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.intelligenceGrowthDashboard, 'Leo 智力成长', 'leoIntelligenceGrowthDashboard'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub, 'ClawPlan 能力总览', 'leoClawPlanCapabilityHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter, '訓練聯邦總控', 'leoTrainingFederationCommandCenter'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDashboard, 'T0–T9 訓練總控台', 'leoTrainingDashboard'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining, 'T2 Golden 訓練', 'leoT2GoldenTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining, 'T9 DeepSeek 訓練', 'leoT9DeepseekTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub, 'PORTAL_OPS 工作台', 'leoKnowledgePortalOpsDailyHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole, 'Portal ops API 盤點台', 'leoKnowledgePortalOpsInventory'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub, 'B 線日常工作台', 'leoDeviceOpsBLineDailyHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining, '語義訓練工作台', 'leoDeviceOpsSemanticTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsBundleCandidates, 'Bundle 候选工作台', 'leoDeviceOpsBundleCandidates'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining, 'T0 入口路由訓練台', 'leoTurnRoutingTrainingHub'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining, 'T6 生產 E2E 訓練', 'leoProductionE2eTraining'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox, 'B 線審核待辦', 'leoDeviceOpsReviewInbox'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen, 'Device_OPS 盤點台', 'leoDeviceOpsDescriptionAutogen'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard, '命令定版向导', 'leoCommandOnboardingWizard'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy, '命令權限總表', 'leoDeviceOpsRolePolicy')
      )
    }
    if (leoView || leoUpload) {
      opsLeaves.push(
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception, '口味／习惯感知', 'leoTasteHabitPerception')
      )
    }
    const opsFolder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.opsWorkbench,
      '運維工作台',
      'leoKnowledgeFolderOps',
      opsLeaves,
      'leo-folder-ops'
    )
    if (opsFolder) groups.push(opsFolder)

    const e1Folder = leoSidebarFolder(
      LEO_SIDEBAR_FOLDER_IDS.deviceIntel,
      '设备智能',
      'leoKnowledgeFolderDeviceIntel',
      [
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Overview, 'E1 总览', 'leoE1Overview', 'leo-e1-overview'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Health, 'E1 机健康', 'leoE1Health', 'leo-e1-health'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Components, 'E1 部件库', 'leoE1Components', 'leo-e1-parts'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Impact, 'E1 影响矩阵', 'leoE1Impact', 'leo-e1-impact'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Production, 'E1 出品联锁', 'leoE1Production', 'leo-e1-production'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Proposals, 'E1 补偿收件箱', 'leoE1Proposals', 'leo-e1-inbox'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Policy, 'E1 白名单策略', 'leoE1Policy', 'leo-e1-policy'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1TargetQuality, 'E1 目标品质', 'leoE1TargetQuality', 'leo-e1-target'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Curves, 'E1 涌现曲线', 'leoE1Curves', 'leo-e1-curves'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1Peer, 'E1 跨机拉齐', 'leoE1Peer', 'leo-e1-peer'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e1LifeGate, 'E1 寿命门', 'leoE1LifeGate', 'leo-e1-life'),
        leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.e2Formulas, 'E2 配方库', 'leoE2Formulas', 'documentation')
      ],
      'leo-e1-device'
    )
    if (e1Folder) groups.push(e1Folder)
  }

  return groups
}

/** 训练湖宿主（德国/AWS）：仅训练运维页；view 即可见 T6/T0 等（勿与 buildLeoKnowledgeSidebarTree 的 upload 门闸混用） */
function buildTrainingLakeSidebarTree (leoView, leoUpload) {
  if (!leoView && !leoUpload) return []
  const leaves = []
  if (leoView) {
    leaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk, '训练决策台', 'leoTrainingDecisionDesk'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.intelligenceGrowthDashboard, 'Leo 智力成长', 'leoIntelligenceGrowthDashboard'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub, 'ClawPlan 能力总览', 'leoClawPlanCapabilityHub'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter, '训练联邦总控', 'leoTrainingFederationCommandCenter'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingDashboard, 'T0–T9 训练总控台', 'leoTrainingDashboard'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining, 'T6 生产 E2E 训练', 'leoProductionE2eTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception, '口味／习惯感知', 'leoTasteHabitPerception'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining, '语义训练工作台', 'leoDeviceOpsSemanticTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsBundleCandidates, 'Bundle 候选工作台', 'leoDeviceOpsBundleCandidates'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining, 'T0 入口路由训练台', 'leoTurnRoutingTrainingHub'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining, 'T2 Golden 训练', 'leoT2GoldenTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining, 'T9 DeepSeek 训练', 'leoT9DeepseekTraining'),
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.trainingFederationCases, '联邦样本浏览', 'leoTrainingFederationCases')
    )
  }
  if (leoUpload) {
    leaves.push(
      leoSidebarLeaf(LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox, 'B 线审核待办', 'leoDeviceOpsReviewInbox')
    )
  }
  const opsFolder = leoSidebarFolder(
    LEO_SIDEBAR_FOLDER_IDS.opsWorkbench,
    '训练运维',
    'leoTrainingLakeFolderOps',
    leaves
  )
  return opsFolder ? [opsFolder] : []
}

function isLegacyApiDeviceConfigRoot (n) {
  return isMixedLegacyDeviceConfigRoot(n)
}

/** 自 API 剔除混掛歷史根：通道葉→channelChildren；Profile 葉→deviceProfileChildren */
function stripLegacyApiDeviceConfigRoot (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) {
    return { tree: [], channelChildren: [], deviceProfileChildren: [] }
  }
  let channelChildren = []
  let deviceProfileChildren = []
  function walk (list) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n) continue
      if (isLegacyApiDeviceConfigRoot(n)) {
        if (Array.isArray(n.menuList) && n.menuList.length) {
          const split = partitionDeviceChannelLeaves(n.menuList)
          channelChildren = channelChildren.concat(split.channelLeaves.map((c) => Object.assign({}, c)))
          deviceProfileChildren = deviceProfileChildren.concat(split.deviceLeaves.map((c) => Object.assign({}, c)))
        }
        continue
      }
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList)
      }
      out.push(copy)
    }
    return out
  }
  return { tree: walk(nodes), channelChildren, deviceProfileChildren }
}

function menuNodeEnName (n) {
  return n && n.enName != null ? String(n.enName).trim() : ''
}

function isDataCenterSidebarRoot (n) {
  if (!n) return false
  const en = menuNodeEnName(n)
  const name = String(n.name || '')
  return en === 'dataCenter' || name === '数据中心' || name === '數據中心'
}

function findDataCenterSidebarParent (nodes) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    if (isDataCenterSidebarRoot(nodes[i])) return nodes[i]
  }
  return null
}

function isX600hGatewaySidebarLeaf (n) {
  if (!n) return false
  if (Number(n.id) === DEVICE_CONFIG_MENU_IDS.x600hGateway) return true
  const en = menuNodeEnName(n)
  if (en === 'x600hGateway' || en === 'x600hGatewayData') return true
  const name = String(n.name || '')
  if (name === 'X600H' || (name.indexOf('X600H') >= 0 && name.indexOf('Gateway') >= 0)) return true
  const url = String(n.url || '').replace(/^\//, '')
  if (url.indexOf('dataCenter-x600h-gateway') >= 0 || url.indexOf('dataCenter/x600hGateway') >= 0) {
    return true
  }
  return false
}

function isSimulatorGroupSidebarRoot (n) {
  if (!n) return false
  return Number(n.id) === DEVICE_CONFIG_MENU_IDS.simulatorGroup || menuNodeEnName(n) === 'simulatorGroup'
}

/** 僅保留「模擬機」分組內的 X600H；其餘（含數據中心、頂層重複）一律剔除 */
function stripX600hGatewayExceptUnderSimulatorGroup (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return nodes
  function walk (list, underSimulator) {
    const out = []
    for (let i = 0; i < list.length; i++) {
      const n = list[i]
      if (!n) continue
      const nowUnder = underSimulator || isSimulatorGroupSidebarRoot(n)
      if (!nowUnder && isX600hGatewaySidebarLeaf(n)) continue
      const copy = Object.assign({}, n)
      if (Array.isArray(n.menuList) && n.menuList.length) {
        copy.menuList = walk(n.menuList, nowUnder)
      }
      out.push(copy)
    }
    return out
  }
  return walk(nodes, false)
}

function isDeviceConfigExclusiveLeaf (n) {
  if (!n) return false
  if (isDeviceConfigExclusiveMenuLeaf(n)) return true
  const en = menuNodeEnName(n)
  if (en && DEVICE_CONFIG_SIDEBAR_LEAF_EN.has(en)) return true
  return DEVICE_CONFIG_SIDEBAR_LEAF_IDS.has(Number(n.id))
}

function isChannelConfigExclusiveLeaf (n) {
  if (!n) return false
  if (isChannelConfigExclusiveMenuLeaf(n)) return true
  const en = menuNodeEnName(n)
  return !!(en && CHANNEL_CONFIG_SIDEBAR_LEAF_EN.has(en))
}

function collectSidebarLeafIds (node, idSet) {
  if (!node) return
  const children = Array.isArray(node.menuList) ? node.menuList : []
  if (!children.length) {
    if (node.id != null) idSet.add(Number(node.id))
    return
  }
  for (let i = 0; i < children.length; i++) collectSidebarLeafIds(children[i], idSet)
}

/** 設備配置 vs 通道配置 vs 出品「通道與綁定」去重 */
function dedupeSidebarChannelVsDeviceConfig (list) {
  if (!Array.isArray(list)) return
  const channelGroup = findMenuNodeById(list, CHANNEL_CONFIG_SIDEBAR_IDS.group)
  const deviceGroup = findMenuNodeById(list, DEVICE_CONFIG_MENU_IDS.group)

  if (channelGroup && Array.isArray(channelGroup.menuList)) {
    channelGroup.menuList = channelGroup.menuList.filter((c) => c && !isDeviceConfigExclusiveLeaf(c))
  }

  const channelLeafIds = new Set()
  const channelLeafEns = new Set()
  if (channelGroup) {
    collectSidebarLeafIds(channelGroup, channelLeafIds)
    for (let i = 0; i < (channelGroup.menuList || []).length; i++) {
      const en = menuNodeEnName(channelGroup.menuList[i])
      if (en) channelLeafEns.add(en)
    }
  }

  if (deviceGroup && Array.isArray(deviceGroup.menuList)) {
    deviceGroup.menuList = deviceGroup.menuList.filter((c) => {
      if (!c) return false
      if (isChannelConfigExclusiveLeaf(c)) return false
      if (channelLeafIds.has(Number(c.id))) return false
      const en = menuNodeEnName(c)
      if (en && channelLeafEns.has(en)) return false
      return true
    })
  }

  const stripElsewhere = (n) => {
    if (!n) return false
    if (channelLeafIds.has(Number(n.id))) return true
    return isChannelConfigExclusiveLeaf(n)
  }

  function walkPrune (nodes, underChannelGroup) {
    if (!Array.isArray(nodes)) return []
    const out = []
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i]
      if (!n) continue
      const inChannel = underChannelGroup || Number(n.id) === CHANNEL_CONFIG_SIDEBAR_IDS.group
      const children = Array.isArray(n.menuList) ? n.menuList : []
      if (!children.length) {
        if (!inChannel && stripElsewhere(n)) continue
        out.push(n)
        continue
      }
      const pruned = walkPrune(children, inChannel)
      if (!inChannel && stripElsewhere(n) && !pruned.length) continue
      out.push(Object.assign({}, n, { menuList: pruned }))
    }
    return out
  }

  const pruned = walkPrune(list, false)
  list.length = 0
  for (let i = 0; i < pruned.length; i++) list.push(pruned[i])

  if (channelGroup && (!channelGroup.menuList || !channelGroup.menuList.length)) {
    const idx = list.findIndex((x) => x && Number(x.id) === CHANNEL_CONFIG_SIDEBAR_IDS.group)
    if (idx >= 0) list.splice(idx, 1)
  }
}

function mergeChannelConfigSidebarMenu (list, channelChildren) {
  const kids = (Array.isArray(channelChildren) ? channelChildren : [])
    .filter((c) => c && !isDeviceConfigExclusiveLeaf(c))
  if (!kids.length) return
  const folder = {
    id: CHANNEL_CONFIG_SIDEBAR_IDS.group,
    name: '通道配置',
    enName: 'channelConfiguration',
    icon: 'link',
    menuList: kids
  }
  const existing = findMenuNodeById(list, CHANNEL_CONFIG_SIDEBAR_IDS.group)
  if (existing) {
    if (!Array.isArray(existing.menuList) || !existing.menuList.length) {
      existing.menuList = kids
    }
    existing.name = '通道配置'
    existing.enName = 'channelConfiguration'
    return
  }
  // 定案：挂出品管理下，禁止一级顶栏
  const productCenter = findProductCenterSidebarParent(list)
  if (productCenter) {
    if (!Array.isArray(productCenter.menuList)) productCenter.menuList = []
    productCenter.menuList.push(folder)
    return
  }
  list.push(folder)
}

/**
 * 部署后旧 sessionStorage.menuList 可能缺 deviceRd／Leo，而 menuApiRaw 已有。
 * 侧栏自愈：按 raw 重跑 merge，避免用户强刷前一直看到「少菜单」。
 */
const SIDEBAR_SSOT_CORE_ENS = ['deviceRdGroup', 'leoKnowledgeGroup']
/** Leo 有分组但仍应出现门户等二级文件夹；缺则判定 session menuList 过期 */
const LEO_SIDEBAR_FOLDER_HINT_ENS = [
  'leoKnowledgeFolderPortal',
  'leoKnowledgeFolderModel',
  'leoKnowledgeFolderIngest',
  'leoKnowledgeFolderProtocol',
  'leoKnowledgeFolderOps',
  'leoKnowledgeFolderDeviceIntel'
]

function reconcileSidebarMenuSsotFromSession () {
  if (typeof sessionStorage === 'undefined') return
  let raw
  let side
  try {
    raw = JSON.parse(sessionStorage.getItem('menuApiRaw') || '[]')
    side = JSON.parse(sessionStorage.getItem('menuList') || '[]')
  } catch (e) {
    return
  }
  if (!Array.isArray(raw) || !raw.length || !Array.isArray(side)) return
  let stale = false
  for (let i = 0; i < SIDEBAR_SSOT_CORE_ENS.length; i++) {
    const en = SIDEBAR_SSOT_CORE_ENS[i]
    if (menuTreeContainsEnName(raw, en) && !menuTreeContainsEnName(side, en)) {
      stale = true
      break
    }
  }
  if (!stale && menuTreeContainsEnName(raw, 'leoKnowledgeGroup')) {
    const hasFolder = LEO_SIDEBAR_FOLDER_HINT_ENS.some((en) => menuTreeContainsEnName(side, en))
    if (!hasFolder) stale = true
  }
  // 模拟机空壳 / 缺 XOS·泡茶机：强制按 raw 再 merge（patch 134 + hydrate）
  if (!stale && menuTreeContainsEnName(side, 'simulatorGroup')) {
    const simHints = ['xosIviSimulator', 'teaMachineSimulator', 'maestroSimulator', 'storefrontSimulator']
    const missingSimLeaf = simHints.some((en) => !menuTreeContainsEnName(side, en))
    if (missingSimLeaf) stale = true
  }
  if (!stale) return
  try {
    const sidebarMenus = mergeDeviceConfigSidebarMenus(raw)
    sessionStorage.setItem('menuList', JSON.stringify(sidebarMenus))
    store.commit('common/updateMenuList', sidebarMenus)
    fnAddDynamicMenuRoutes(sidebarMenus)
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[router] reconcileSidebarMenuSsotFromSession', e)
    }
  }
}

/** 侧栏树形与角色授权树对齐：nav 扁平 → 同 buildRolePermissionTree 骨架 + 仅允许静态注入/去重 */
function mergeDeviceConfigSidebarMenus (apiMenuList) {
  const raw = Array.isArray(apiMenuList) ? apiMenuList : []
  const legacyDeviceConfig = stripLegacyApiDeviceConfigRoot(raw.slice())
  const navFlat = reparentLeoOpsOutOfSystemSettings(flattenNavTreeToFlatList(raw))
  let list = buildSidebarNavTreeFromFlat(navFlat)
  enrichSidebarNodesFromNavTree(list, raw)
  list = stripShadowedSimulatorMenusFromApi(list)
  // Leo 根治：DB 已有二级文件夹（patch 133）→ 禁止 strip/rebuild，侧栏=授权树。
  // 仅当库仍扁平（未跑 133）时兜底 strip + 静态文件夹树。
  const leoDbFoldersPresent = LEO_SIDEBAR_FOLDER_HINT_ENS.some((en) => menuTreeContainsEnName(list, en)) ||
    menuTreeContainsNodeId(list, LEO_SIDEBAR_FOLDER_IDS.portalOverview) ||
    menuTreeContainsNodeId(list, LEO_SIDEBAR_FOLDER_IDS.opsWorkbench)
  if (!leoDbFoldersPresent) {
    list = stripShadowedLeoKnowledgeMenusFromApi(list)
  }
  list = stripShadowedLinuxAutoMenusFromApi(list)
  stripLeoOpsFromSystemSettingsTree(list)
  if (isTrainingLakeHost()) {
    const { leoView, leoUpload } = resolveLeoKnowledgeSidebarGates(raw)
    if (leoView || leoUpload) {
      const leoMenuList = buildTrainingLakeSidebarTree(leoView, leoUpload)
      if (leoMenuList.length) {
        list = list.filter((n) => menuNodeNumericId(n) !== LEO_KNOWLEDGE_MENU_IDS.group)
        list.push({
          id: LEO_KNOWLEDGE_MENU_IDS.group,
          name: '训练湖',
          enName: 'leoTrainingLakeGroup',
          icon: 'chart',
          menuList: leoMenuList
        })
      }
    }
    applySidebarRbacFilter(list, raw)
    fillSidebarMenuIcons(list)
    stripTopLevelSidebarNodeByIdOrEn(list, null, XRROSS_INTRO_ROUTE.groupEnName)
    return list
  }
  if (apiMenuTreeContainsDeviceConfigRoot(raw) &&
      !menuTreeContainsNodeId(list, LEGACY_CHANNEL_CONFIG_API_ROOT_ID) &&
      !menuTreeContainsEnName(list, 'deviceConfig') &&
      !menuTreeContainsNodeId(list, DEVICE_CONFIG_MENU_IDS.group)) {
    const deviceKids = (legacyDeviceConfig.deviceProfileChildren || []).filter(Boolean)
    if (deviceKids.length) {
      list.push({
        id: DEVICE_CONFIG_MENU_IDS.group,
        name: '設備配置',
        enName: 'deviceConfig',
        icon: 'machine',
        menuList: deviceKids.map((c) => Object.assign({}, c))
      })
    }
  }
  mergeChannelConfigSidebarMenu(list, legacyDeviceConfig.channelChildren)
  const navAllowsSimulator = apiMenuTreeContainsSimulatorMerge(raw)
  const { leoView, leoUpload } = resolveLeoKnowledgeSidebarGates(raw)
  if (leoView || leoUpload) {
    const sysForUi = list.find(x => x && (x.enName === 'systemSetting' || x.name === '系统设置' || x.name === '系統設定'))
    if (sysForUi && Array.isArray(sysForUi.menuList) && !menuTreeContainsNodeId(list, SYSTEM_SETTINGS_PLATFORM_MENU_IDS.uiSurfaceSample)) {
      sysForUi.menuList.push({
        id: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.uiSurfaceSample,
        name: '後台視覺樣板（灰底）',
        enName: 'leoKnowledgeUiSurfaceSample',
        icon: 'theme'
      })
    }
    if (leoUpload && sysForUi && Array.isArray(sysForUi.menuList)
        && !menuTreeContainsNodeId(list, SYSTEM_SETTINGS_PLATFORM_MENU_IDS.aiTrusteeAdmin)) {
      sysForUi.menuList.unshift({
        id: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.aiTrusteeAdmin,
        name: 'AI 托管管理台',
        enName: 'aiTrusteeAdmin',
        icon: 'switch'
      })
    }
  }
  if ((leoView || leoUpload) && !menuTreeContainsNodeId(list, LEO_KNOWLEDGE_MENU_IDS.group) && !leoDbFoldersPresent) {
    const leoMenuList = buildLeoKnowledgeSidebarTree(leoView, leoUpload)
    if (leoMenuList.length) {
      list.push({
        id: LEO_KNOWLEDGE_MENU_IDS.group,
        name: 'Leo 知識庫',
        enName: 'leoKnowledgeGroup',
        icon: 'documentation',
        menuList: leoMenuList
      })
    }
  }
  mergeMemberHqMenu(list)
  mergeMerchantTokenBillingPlatformMenu(list)
  mergeMerchantDataBillingPlatformMenu(list)
  mergeProduceFivePosMenu(list)
  mergeDataCenterCoffeeMachineMenus(list, raw)
  mergeX600hRecipeCenterProductCenterSidebar(list)
  mergeProductCenterSidebarTree(list)
  mergeAfterSalesServiceSidebarMenu(list)
  mergeLinuxAutoOpsMenu(list)
  dedupeSidebarChannelVsDeviceConfig(list)
  list = stripX600hGatewayExceptUnderSimulatorGroup(list)
  mergeSimulatorSidebarUnderDevices(list, navAllowsSimulator)
  mergeDeviceRdSidebarGroup(list, navAllowsSimulator)
  mergeX600hProductionOrderSidebar(list)
  applySidebarRbacFilter(list, raw)
  fillSidebarMenuIcons(list)
  // 認識 XRROSS：頂欄常駐，不進側欄（patch 222 刪庫；勿再用 990440，已讓給設備需求單查看鈕）
  stripTopLevelSidebarNodeByIdOrEn(list, null, XRROSS_INTRO_ROUTE.groupEnName)
  return list
}

/** 出品管理 · X600H 配方中心 — 禁止前端硬注入；僅 coffee_menu 990401 + role_menu */
function mergeX600hRecipeCenterProductCenterSidebar (_list) {
  /* no-op — 側欄與授權樹同認 DB nav */
}

/** 設備管理下「模擬機」二級分組（靜態樹；對齊 coffee_menu 990105） */
function buildSimulatorGroupSidebarNode () {
  return {
    id: DEVICE_CONFIG_MENU_IDS.simulatorGroup,
    name: '模擬機',
    enName: 'simulatorGroup',
    icon: 'machine_model',
    menuList: [
      {
        id: DEVICE_CONFIG_MENU_IDS.x600hGateway,
        name: 'X600H',
        enName: 'x600hGateway',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator,
        name: 'XT90C2',
        enName: 'xt90c2Simulator',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.blenderSimulator,
        name: 'Blender',
        enName: 'blenderSimulator',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.xosIviSimulator,
        name: 'XOS',
        enName: 'xosIviSimulator',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator,
        name: 'Hansong IVI',
        enName: 'hansonIviSimulator',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.teaMachineSimulator,
        name: '泡茶机',
        enName: 'teaMachineSimulator',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.maestroSimulator,
        name: 'Maestro',
        enName: 'maestroSimulator',
        icon: ''
      },
      {
        id: DEVICE_CONFIG_MENU_IDS.storefrontSimulator,
        name: '点单机Kiosk',
        enName: 'storefrontSimulator',
        icon: ''
      }
    ]
  }
}

function stripTopLevelSidebarNodeByIdOrEn (nodes, id, enName) {
  if (!Array.isArray(nodes)) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    const idHit = id != null && id !== '' && Number(n.id) === Number(id)
    const enHit = !!(enName && menuNodeEnName(n) === enName)
    if (idHit || enHit) {
      nodes.splice(i, 1)
    }
  }
}

/** 設備管理／頂層重複 990105：只剔重，不碰「设备研发」下模擬機（patch 134） */
function mergeSimulatorSidebarUnderDevices (list, _navAllowsSimulator) {
  if (!Array.isArray(list)) return
  stripTopLevelSidebarNodeByIdOrEn(list, DEVICE_CONFIG_MENU_IDS.simulatorGroup, 'simulatorGroup')
  const devicesGroup = findDevicesSidebarParent(list)
  if (devicesGroup && Array.isArray(devicesGroup.menuList)) {
    for (let i = devicesGroup.menuList.length - 1; i >= 0; i--) {
      const n = devicesGroup.menuList[i]
      if (!n) continue
      if (Number(n.id) === DEVICE_CONFIG_MENU_IDS.simulatorGroup || menuNodeEnName(n) === 'simulatorGroup') {
        devicesGroup.menuList.splice(i, 1)
      }
    }
  }
}

function detachSidebarNodeByIdOrEn (nodes, id, enName) {
  if (!Array.isArray(nodes)) return null
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Number(n.id) === Number(id) || (enName && menuNodeEnName(n) === enName)) {
      nodes.splice(i, 1)
      return Object.assign({}, n)
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = detachSidebarNodeByIdOrEn(n.menuList, id, enName)
      if (hit) return hit
    }
  }
  return null
}

function insertSidebarNodeAfterDevices (list, node) {
  if (!Array.isArray(list) || !node) return
  const idx = list.findIndex((n) => {
    if (!n) return false
    return (
      Number(n.id) === DEVICE_MANAGEMENT_MENU_IDS.group ||
      menuNodeEnName(n) === 'devices' ||
      menuNodeEnName(n) === 'device'
    )
  })
  if (idx >= 0) {
    list.splice(idx + 1, 0, node)
  } else {
    list.push(node)
  }
}

/**
 * 设备研发已在库时：确保 simulatorGroup 具备全量子叶（修 early-return 空壳）。
 */
function ensureSimulatorGroupHydratedUnderDeviceRd (list, navAllowsSimulator) {
  if (!Array.isArray(list)) return
  const rd = list.find(
    (n) => n && (Number(n.id) === DEVICE_RD_MENU_IDS.group || menuNodeEnName(n) === 'deviceRdGroup')
  )
  if (!rd) return
  if (!Array.isArray(rd.menuList)) rd.menuList = []
  let simIdx = rd.menuList.findIndex(
    (n) => n && (Number(n.id) === DEVICE_CONFIG_MENU_IDS.simulatorGroup || menuNodeEnName(n) === 'simulatorGroup')
  )
  const full = buildSimulatorGroupSidebarNode()
  if (simIdx < 0) {
    if (!(navAllowsSimulator && hasSimulatorSidebarPermission())) return
    const afterDebug = rd.menuList.findIndex(
      (n) => n && (Number(n.id) === DEVICE_RD_MENU_IDS.machineDebug || menuNodeEnName(n) === 'machineDebug')
    )
    if (afterDebug >= 0) rd.menuList.splice(afterDebug + 1, 0, full)
    else rd.menuList.unshift(full)
    return
  }
  const sim = rd.menuList[simIdx]
  if (!Array.isArray(sim.menuList)) sim.menuList = []
  const have = new Set()
  sim.menuList.forEach((c) => {
    if (!c) return
    if (c.id != null) have.add(String(c.id))
    const en = menuNodeEnName(c)
    if (en) have.add('en:' + en)
  })
  ;(full.menuList || []).forEach((leaf) => {
    if (!leaf) return
    const en = menuNodeEnName(leaf)
    if (have.has(String(leaf.id)) || (en && have.has('en:' + en))) return
    sim.menuList.push(Object.assign({}, leaf))
  })
  rd.menuList[simIdx] = sim
}

/** 侧栏「设备研发」：DB 已有 990130 时 hydrate 模拟机子叶；否则 legacy 聚合 */
function mergeDeviceRdSidebarGroup (list, navAllowsSimulator) {
  if (!Array.isArray(list)) return

  if (menuTreeContainsNodeId(list, DEVICE_RD_MENU_IDS.group)) {
    ensureSimulatorGroupHydratedUnderDeviceRd(list, navAllowsSimulator)
    return
  }

  const children = []

  const machineDebug = detachSidebarNodeByIdOrEn(list, DEVICE_RD_MENU_IDS.machineDebug, 'machineDebug')
  if (machineDebug) children.push(machineDebug)

  let simulator = detachSidebarNodeByIdOrEn(list, DEVICE_RD_MENU_IDS.simulatorGroup, 'simulatorGroup')
  if (!simulator && navAllowsSimulator && hasSimulatorSidebarPermission()) {
    simulator = buildSimulatorGroupSidebarNode()
  }
  if (simulator) children.push(simulator)

  const deviceConfig = detachSidebarNodeByIdOrEn(
    list,
    DEVICE_RD_MENU_IDS.deviceConfigGroup,
    'deviceConfig'
  )
  if (deviceConfig) children.push(deviceConfig)

  const linkDebug = detachSidebarNodeByIdOrEn(list, DEVICE_RD_MENU_IDS.deviceLinkDebug, 'deviceLinkDebug')
  if (linkDebug) children.push(linkDebug)

  const equipmentModelRepair = detachSidebarNodeByIdOrEn(
    list,
    DEVICE_RD_MENU_IDS.equipmentModelRepair,
    'equipmentModelRepair'
  )
  if (equipmentModelRepair) children.push(equipmentModelRepair)

  const partnerApiAdmin = detachSidebarNodeByIdOrEn(
    list,
    DEVICE_RD_MENU_IDS.partnerApiAdmin,
    'partnerApiAdmin'
  )
  if (partnerApiAdmin) children.push(partnerApiAdmin)

  if (!children.length) return

  insertSidebarNodeAfterDevices(list, {
    id: DEVICE_RD_MENU_IDS.group,
    name: '设备研发',
    enName: 'deviceRdGroup',
    icon: 'operation',
    menuList: children
  })
}

/** 设备管理侧栏：X600H 生产订单 — 仅 x600h:production-order:* 或 nav 已授权 */
function mergeX600hProductionOrderSidebar (list) {
  if (!Array.isArray(list)) return
  if (!canAccessX600hProductionOrderMenu()) return
  if (menuTreeContainsNodeId(list, X600H_PRODUCTION_ORDER_MENU_IDS.list)) return
  const devicesGroup = findDevicesSidebarParent(list)
  if (!devicesGroup) return
  if (!Array.isArray(devicesGroup.menuList)) devicesGroup.menuList = []
  devicesGroup.menuList.push({
    id: X600H_PRODUCTION_ORDER_MENU_IDS.list,
    name: 'X600H 生产订单',
    enName: 'x600hProductionOrder',
    icon: 'machine_model'
  })
}

/** 與 extras 的 path 比較用（有無前導 / 視為同一路由） */
function pathKey (p) {
  return String(p == null ? '' : p).replace(/^\//, '')
}

/** 設備自動售后：靜態 extras 註冊，勿再生成 component 可能為空的動態路由 */
function isDeviceServiceMenuItem (menuItem) {
  if (!menuItem || menuItem.id == null) return false
  const id = Number(menuItem.id)
  return id >= DEVICE_SERVICE_MENU_IDS.workbench && id <= DEVICE_SERVICE_MENU_IDS.analytics
}

/** 排班出勤：視圖在 folder/index.vue，動態 _import(url) 會空 component；僅走 extras 靜態頁 */
function isWorkforceMenuItem (menuItem) {
  if (!menuItem || menuItem.id == null) return false
  const id = Number(menuItem.id)
  return id >= WORKFORCE_MENU_IDS.group && id <= WORKFORCE_MENU_IDS.myScheduleView
}

/** 无人运营决策例外：同上，仅走 extras 静态页 */
function isStoreAutopilotMenuItem (menuItem) {
  if (!menuItem || menuItem.id == null) return false
  const id = Number(menuItem.id)
  return id >= STORE_AUTOPILOT_MENU_IDS.group && id <= STORE_AUTOPILOT_MENU_IDS.exceptionsView
}

/** 認識 XRROSS／對外介紹：仅走 extras；按 enName（禁止再用 990440–442 區間，990440 已是生態商城按鈕） */
function isXrrossIntroMenuItem (menuItem) {
  if (!menuItem) return false
  const en = String(menuItem.enName || '')
  return en === XRROSS_INTRO_ROUTE.groupEnName || en === XRROSS_INTRO_ROUTE.hubEnName
}

/** E1／E2：DB url 為 /leo-e*，動態 _import 會空 component；僅走 extras 靜態頁 */
function isLeoE1MenuItem (menuItem) {
  if (!menuItem || menuItem.id == null) return false
  const id = Number(menuItem.id)
  return id === LEO_KNOWLEDGE_MENU_IDS.e1Overview ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Components ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Proposals ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Production ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Health ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Impact ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Policy ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1TargetQuality ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Curves ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1Peer ||
    id === LEO_KNOWLEDGE_MENU_IDS.e1LifeGate ||
    id === LEO_KNOWLEDGE_MENU_IDS.e2Formulas
}

/**
 * 靜態子路由在前、動態在後；依 name／path 去重（先出現者保留，即靜態優先）。
 * 禁止子路由 name 為 main（與父級 Layout 路由 name: main 衝突，vue-router 會報 Duplicate named routes）。
 */
function dedupeMainChildrenFirstWins (children) {
  const seenName = new Set()
  const seenPath = new Set()
  const out = []
  for (var i = 0; i < children.length; i++) {
    const c = children[i]
    if (!c) continue
    if (c.name === 'main') continue
    const pk = pathKey(c.path)
    if (c.name && seenName.has(c.name)) continue
    if (pk && seenPath.has(pk)) continue
    if (c.name) seenName.add(c.name)
    if (pk) seenPath.add(pk)
    out.push(c)
  }
  return out
}

/**
 * 靜態 main 子路由已在 Router 初始註冊；後端 menu 與 appendStaticDeviceConfigRoutes 的 extras
 * 常與 STATIC_MAIN_CHILDREN_SNAPSHOT 同名／同 path，若直接 concat 再 addRoute 會觸發 Duplicate named routes。
 */
function dedupeDynamicRoutesAgainstStatic (dynamicRoutes) {
  const staticList = STATIC_MAIN_CHILDREN_SNAPSHOT
  const staticNames = new Set()
  const staticPathKeys = new Set()
  for (var si = 0; si < staticList.length; si++) {
    var st = staticList[si]
    if (!st) continue
    if (st.name) staticNames.add(st.name)
    var spk = pathKey(st.path)
    if (spk) staticPathKeys.add(spk)
  }
  const seenName = new Set()
  const seenPath = new Set()
  const out = []
  for (var k = 0; k < dynamicRoutes.length; k++) {
    var r = dynamicRoutes[k]
    if (!r) continue
    if (r.name === 'main') continue
    var pk = pathKey(r.path)
    if (r.name && staticNames.has(r.name)) continue
    if (pk && staticPathKeys.has(pk)) continue
    if (r.name && seenName.has(r.name)) continue
    if (pk && seenPath.has(pk)) continue
    if (r.name) seenName.add(r.name)
    if (pk) seenPath.add(pk)
    out.push(r)
  }
  return out
}

/**
 * 設備配置在線化：合併進動態路由（無後台選單項時仍可進入），對齊 DEVICE_CONFIG_UI_STANDARD_V1。
 * 若 menuApi 已寫入同名 path / name 但 _import 失敗（component 空），舊邏輯會「跳過」靜態 extras → 導向 * 回退 404。
 * 此處改為先移除衝突項再寫入正確靜態路由，確保可進入。
 */
function appendStaticDeviceConfigRoutes (routes) {
  const extras = [
    {
      path: '/deviceConfig-profileList',
      component: _import('deviceConfig/profileList'),
      name: 'deviceConfig-profileList',
      meta: {
        title: '配置檔庫',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.profileList,
        id: DEVICE_CONFIG_MENU_IDS.profileList
      }
    },
    {
      path: '/deviceConfig-profileWorkbench',
      component: _import('deviceConfig/profileWorkbench'),
      name: 'deviceConfig-profileWorkbench',
      meta: {
        title: 'Profile 工作台',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.workbench,
        id: DEVICE_CONFIG_MENU_IDS.workbench
      }
    },
    {
      path: '/deviceConfig-bindings',
      component: _import('deviceConfig/bindings'),
      name: 'deviceConfig-bindings',
      meta: {
        title: '配置綁定與下發',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.bindings,
        id: DEVICE_CONFIG_MENU_IDS.bindings
      }
    },
    {
      path: '/deviceConfig-coffeeMachineChannels',
      component: _import('deviceConfig/coffeeMachineChannelConfig'),
      name: 'deviceConfig-coffeeMachineChannels',
      meta: {
        title: 'X600H配方中心',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels,
        id: DEVICE_CONFIG_MENU_IDS.coffeeMachineChannels
      }
    },
    {
      path: '/device-x600h-production-order',
      component: _import('device/x600hProductionOrder/index'),
      name: 'x600hProductionOrder',
      meta: {
        title: 'X600H 生产订单',
        isTab: true,
        isDynamic: false,
        menuId: X600H_PRODUCTION_ORDER_MENU_IDS.list,
        id: X600H_PRODUCTION_ORDER_MENU_IDS.list
      }
    },
    {
      path: '/dataCenter-x600h-gateway',
      component: _import('dataCenter/x600hGateway/index'),
      name: 'x600hGatewayData',
      meta: {
        title: 'X600H',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.x600hGateway,
        id: DEVICE_CONFIG_MENU_IDS.x600hGateway
      }
    },
    {
      path: '/simulator-xt90c2',
      component: _import('dataCenter/x600hGateway/index'),
      name: 'xt90c2Simulator',
      meta: {
        title: 'XT90C2 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator,
        id: DEVICE_CONFIG_MENU_IDS.xt90c2Simulator
      }
    },
    {
      path: '/simulator-blender',
      component: _import('simulator/blender/index'),
      name: 'blenderSimulator',
      meta: {
        title: 'Blender 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.blenderSimulator,
        id: DEVICE_CONFIG_MENU_IDS.blenderSimulator
      }
    },
    {
      path: '/simulator-xos-ivi',
      component: _import('simulator/xosIvi/index'),
      name: 'xosIviSimulator',
      meta: {
        title: 'XOS 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.xosIviSimulator,
        id: DEVICE_CONFIG_MENU_IDS.xosIviSimulator
      }
    },
    {
      path: '/simulator-hanson-ivi',
      component: _import('simulator/hansonIvi/index'),
      name: 'hansonIviSimulator',
      meta: {
        title: 'Hansong IVI 模擬機',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator,
        id: DEVICE_CONFIG_MENU_IDS.hansonIviSimulator
      }
    },
    {
      path: '/simulator-tea-machine',
      component: _import('simulator/teaMachine/index'),
      name: 'teaMachineSimulator',
      meta: {
        title: '泡茶机模拟机',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.teaMachineSimulator,
        id: DEVICE_CONFIG_MENU_IDS.teaMachineSimulator
      }
    },
    {
      path: '/simulator-maestro',
      component: _import('simulator/maestro/index'),
      name: 'maestroSimulator',
      meta: {
        title: 'Maestro模拟机',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.maestroSimulator,
        id: DEVICE_CONFIG_MENU_IDS.maestroSimulator
      }
    },
    {
      path: '/simulator-storefront',
      component: _import('simulator/storefront/index'),
      name: 'storefrontSimulator',
      meta: {
        title: '点单机Kiosk模拟机',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_CONFIG_MENU_IDS.storefrontSimulator,
        id: DEVICE_CONFIG_MENU_IDS.storefrontSimulator
      }
    },
    {
      path: '/leo-knowledge-portal-hub',
      component: _import('leoKnowledge/LeoPortalAndConsoleHub'),
      name: 'leoKnowledgePortalHub',
      meta: {
        title: i18n.t('route.leoKnowledgePortalHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.portalHub,
        id: LEO_KNOWLEDGE_MENU_IDS.portalHub,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-in-car',
      component: _import('leoKnowledge/LeoInCarHub'),
      name: 'leoInCarHub',
      meta: {
        title: 'Leo.in.Car',
        isTab: true,
        isDynamic: false,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-at-home',
      component: _import('leoKnowledge/LeoAtHomeHub'),
      name: 'leoAtHomeHub',
      meta: {
        title: 'Leo.at.Home',
        isTab: true,
        isDynamic: false,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-in-biz',
      component: _import('leoKnowledge/LeoInBizHub'),
      name: 'leoInBizHub',
      meta: {
        title: 'Leo.in.Biz',
        isTab: true,
        isDynamic: false,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/ui-surface-sample',
      component: _import('common/UiSurfaceSample'),
      name: 'leoKnowledgeUiSurfaceSample',
      meta: {
        title: i18n.t('route.leoKnowledgeUiSurfaceSample'),
        isTab: true,
        isDynamic: false,
        menuId: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.uiSurfaceSample,
        id: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.uiSurfaceSample,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/system-ai-trustee-admin',
      beforeEnter (to, from, next) {
        if (to.query && to.query.tab === 'taste_habit') {
          const q = { ...to.query }
          delete q.tab
          next({ path: '/leo-taste-habit-perception', query: q })
          return
        }
        next()
      },
      component: _import('systemSetting/AiTrusteeAdminConsole'),
      name: 'aiTrusteeAdminConsole',
      meta: {
        title: i18n.t('route.aiTrusteeAdmin'),
        isTab: true,
        isDynamic: false,
        menuId: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.aiTrusteeAdmin,
        id: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.aiTrusteeAdmin,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/system-agent-permission-steward',
      component: _import('systemSetting/AgentPermissionStewardConsole'),
      name: 'agentPermissionStewardConsole',
      meta: {
        title: i18n.t('route.agentPermissionSteward'),
        isTab: true,
        isDynamic: false,
        menuId: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.agentPermissionSteward,
        id: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.agentPermissionSteward
      }
    },
    {
      path: '/system-platform-release-control',
      component: _import('systemSetting/PlatformReleaseControlConsole'),
      name: 'platformReleaseControlConsole',
      meta: {
        title: '發版總管',
        isTab: true,
        isDynamic: false,
        menuId: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.platformReleaseControl,
        id: SYSTEM_SETTINGS_PLATFORM_MENU_IDS.platformReleaseControl
      }
    },
    {
      path: '/system-equipment-model-repair',
      component: _import('systemSetting/equipmentModelRepair/index'),
      name: 'equipmentModelRepairConsole',
      meta: {
        title: '設備型號修復',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_RD_MENU_IDS.equipmentModelRepair,
        id: DEVICE_RD_MENU_IDS.equipmentModelRepair
      }
    },
    {
      path: '/system-partner-api-admin',
      component: _import('systemSetting/partnerApiAdmin/index'),
      name: 'partnerApiAdminConsole',
      meta: {
        title: '三方API管理',
        isTab: true,
        isDynamic: false,
        menuId: DEVICE_RD_MENU_IDS.partnerApiAdmin,
        id: DEVICE_RD_MENU_IDS.partnerApiAdmin
      }
    },
    {
      path: '/leo-knowledge-model-fields',
      component: _import('leoKnowledge/ModelKnowledgeForm'),
      name: 'leoKnowledgeModelFields',
      meta: {
        title: '型號知識欄位',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.modelFields,
        id: LEO_KNOWLEDGE_MENU_IDS.modelFields,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-equipment-type-typekey',
      component: _import('leoKnowledge/EquipmentTypeTypeKeyAdmin'),
      name: 'leoKnowledgeEquipmentTypeTypeKey',
      meta: {
        title: '設備類型 type_key',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.equipmentTypeTypeKey,
        id: LEO_KNOWLEDGE_MENU_IDS.equipmentTypeTypeKey,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-upload',
      component: _import('leoKnowledge/KnowledgeUpload'),
      name: 'leoKnowledgeUpload',
      meta: {
        title: '知識上傳',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.upload,
        id: LEO_KNOWLEDGE_MENU_IDS.upload,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-ingest-batch',
      component: _import('leoKnowledge/IngestBatch'),
      name: 'leoKnowledgeIngestBatch',
      meta: {
        title: '入庫批次（自動建立）',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.ingestBatch,
        id: LEO_KNOWLEDGE_MENU_IDS.ingestBatch,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-phase1-ssot',
      component: _import('leoKnowledge/Phase1SsotTrigger'),
      name: 'leoKnowledgePhase1Ssot',
      meta: {
        title: 'Phase1 SSOT 管線',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.phase1Ssot,
        id: LEO_KNOWLEDGE_MENU_IDS.phase1Ssot,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-capability-matrix',
      component: _import('leoKnowledge/CapabilityMatrix'),
      name: 'leoKnowledgeCapabilityMatrix',
      meta: {
        title: '能力矩陣',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.capabilityMatrix,
        id: LEO_KNOWLEDGE_MENU_IDS.capabilityMatrix,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-taste-habit-perception',
      component: _import('leoKnowledge/TasteHabitPerceptionEditor'),
      name: 'leoTasteHabitPerception',
      meta: {
        title: '口味／习惯感知',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception,
        id: LEO_KNOWLEDGE_MENU_IDS.tasteHabitPerception,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-t7-taste-ml',
      component: _import('leoKnowledge/T7TasteMlWorkbench'),
      name: 'leoT7TasteMl',
      meta: {
        title: 'T7 口味 ML',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.t7TasteMl,
        id: LEO_KNOWLEDGE_MENU_IDS.t7TasteMl,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-knowledge-onboarding',
      component: _import('leoKnowledge/onboarding/index'),
      name: 'leoKnowledgeOnboarding',
      meta: {
        title: '智慧型號引導',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.onboarding,
        id: LEO_KNOWLEDGE_MENU_IDS.onboarding,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-tester-console',
      component: _import('leoKnowledge/TesterConsole'),
      name: 'leoKnowledgeTesterConsole',
      meta: {
        title: '測試員主控台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.testerConsole,
        id: LEO_KNOWLEDGE_MENU_IDS.testerConsole,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-pipeline-hub',
      component: _import('leoKnowledge/pipeline/PipelineHub'),
      name: 'leoKnowledgePipelineHub',
      meta: {
        title: 'Leo 管線總覽',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.pipelineHub,
        id: LEO_KNOWLEDGE_MENU_IDS.pipelineHub,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-feature-surface',
      component: _import('leoKnowledge/pipeline/FeatureSurfaceMap'),
      name: 'leoKnowledgeFeatureSurface',
      meta: {
        title: '功能→API 映射',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.featureSurface,
        id: LEO_KNOWLEDGE_MENU_IDS.featureSurface,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-protocol-index',
      component: _import('leoKnowledge/pipeline/ProtocolDocIndex'),
      name: 'leoKnowledgeProtocolDoc',
      meta: {
        title: '協議文檔索引',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.protocolDoc,
        id: LEO_KNOWLEDGE_MENU_IDS.protocolDoc,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-remote-tools',
      component: _import('leoKnowledge/pipeline/RemoteToolCatalog'),
      name: 'leoKnowledgeRemoteTools',
      meta: {
        title: '遙控工具目錄',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.remoteTool,
        id: LEO_KNOWLEDGE_MENU_IDS.remoteTool,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-xee-growth',
      component: _import('leoKnowledge/XeeGrowthDashboard'),
      name: 'leoXeeGrowthDashboard',
      meta: {
        title: 'XEE · Leo 成長',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard,
        id: LEO_KNOWLEDGE_MENU_IDS.xeeGrowthDashboard,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-device-ops-b-line-daily-hub',
      component: _import('leoKnowledge/DeviceOpsBLineDailyHub'),
      name: 'leoDeviceOpsBLineDailyHub',
      meta: {
        title: i18n.t('route.leoDeviceOpsBLineDailyHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsBLineDailyHub,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-semantic-training',
      component: _import('leoKnowledge/DeviceOpsSemanticTraining'),
      name: 'leoDeviceOpsSemanticTraining',
      meta: {
        title: 'device_ops 語義訓練台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsSemanticTraining,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-device-ops-bundle-candidates',
      component: _import('leoKnowledge/DeviceOpsBundleCandidates'),
      name: 'leoDeviceOpsBundleCandidates',
      meta: {
        title: 'Bundle 候选工作台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsBundleCandidates,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsBundleCandidates,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-training-decision-desk',
      component: _import('leoKnowledge/LeoTrainingDecisionDesk'),
      name: 'leoTrainingDecisionDesk',
      meta: {
        title: '训练决策台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingDecisionDesk,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-intelligence-growth',
      component: _import('leoKnowledge/LeoIntelligenceGrowthDashboard'),
      name: 'leoIntelligenceGrowthDashboard',
      meta: {
        title: 'Leo 智力成长',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.intelligenceGrowthDashboard,
        id: LEO_KNOWLEDGE_MENU_IDS.intelligenceGrowthDashboard,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-e1-overview',
      component: _import('leoE1/overview'),
      name: 'leoE1Overview',
      meta: {
        title: 'E1 总览',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Overview,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Overview
      }
    },
    {
      path: '/leo-e1-components',
      component: _import('leoE1/components'),
      name: 'leoE1Components',
      meta: {
        title: 'E1 部件库',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Components,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Components
      }
    },
    {
      path: '/leo-e1-proposals',
      component: _import('leoE1/proposals'),
      name: 'leoE1Proposals',
      meta: {
        title: 'E1 补偿收件箱',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Proposals,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Proposals
      }
    },
    {
      path: '/leo-e1-production',
      component: _import('leoE1/production'),
      name: 'leoE1Production',
      meta: {
        title: 'E1 出品联锁',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Production,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Production
      }
    },
    {
      path: '/leo-e1-device',
      component: _import('leoE1/deviceProfile'),
      name: 'leoE1DeviceProfile',
      meta: {
        title: 'E1 机档案',
        isTab: true,
        isDynamic: false
        // 勿挂 e1Overview menuId：appendStatic 按 menuId 去重会挤掉「E1 总览」→ 侧栏点开空白机档案
      }
    },
    {
      path: '/leo-e1-health',
      component: _import('leoE1/health'),
      name: 'leoE1Health',
      meta: {
        title: 'E1 机健康',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Health,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Health
      }
    },
    {
      path: '/leo-e1-impact',
      component: _import('leoE1/impact'),
      name: 'leoE1Impact',
      meta: {
        title: 'E1 影响矩阵',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Impact,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Impact
      }
    },
    {
      path: '/leo-e1-policy',
      component: _import('leoE1/policy'),
      name: 'leoE1Policy',
      meta: {
        title: 'E1 白名单策略',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Policy,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Policy
      }
    },
    {
      path: '/leo-e1-target-quality',
      component: _import('leoE1/targetQuality'),
      name: 'leoE1TargetQuality',
      meta: {
        title: 'E1 目标品质',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1TargetQuality,
        id: LEO_KNOWLEDGE_MENU_IDS.e1TargetQuality
      }
    },
    {
      path: '/leo-e1-curves',
      component: _import('leoE1/curves'),
      name: 'leoE1Curves',
      meta: {
        title: 'E1 涌现曲线',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Curves,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Curves
      }
    },
    {
      path: '/leo-e1-peer',
      component: _import('leoE1/peer'),
      name: 'leoE1Peer',
      meta: {
        title: 'E1 跨机拉齐',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1Peer,
        id: LEO_KNOWLEDGE_MENU_IDS.e1Peer
      }
    },
    {
      path: '/leo-e1-life-gate',
      component: _import('leoE1/lifeGate'),
      name: 'leoE1LifeGate',
      meta: {
        title: 'E1 寿命门',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e1LifeGate,
        id: LEO_KNOWLEDGE_MENU_IDS.e1LifeGate
      }
    },
    {
      path: '/leo-e2-formulas',
      component: _import('leoE2/formulas'),
      name: 'leoE2Formulas',
      meta: {
        title: 'E2 配方库',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.e2Formulas,
        id: LEO_KNOWLEDGE_MENU_IDS.e2Formulas
      }
    },
    {
      path: '/leo-clawplan-capability-hub',
      component: _import('leoKnowledge/LeoClawPlanCapabilityHub'),
      name: 'leoClawPlanCapabilityHub',
      meta: {
        title: 'ClawPlan 能力总览',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub,
        id: LEO_KNOWLEDGE_MENU_IDS.clawPlanCapabilityHub,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-training-federation-command-center',
      component: _import('leoKnowledge/LeoTrainingFederationCommandCenter'),
      name: 'leoTrainingFederationCommandCenter',
      meta: {
        title: '訓練聯邦總控',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCommandCenter,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-usage-habit-wizard-metrics',
      component: _import('leoKnowledge/UsageHabitWizardMetrics'),
      name: 'leoUsageHabitWizardMetrics',
      meta: {
        title: '使用習慣引導漏斗',
        isTab: true,
        isDynamic: false,
        menuId: '990280',
        id: '990280',
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-training-dashboard',
      component: _import('leoKnowledge/LeoTrainingDashboard'),
      name: 'leoTrainingDashboard',
      meta: {
        title: 'T0–T9 訓練總控台',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingDashboard,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingDashboard,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-t2-golden-training',
      component: _import('leoKnowledge/T2GoldenTraining'),
      name: 'leoT2GoldenTraining',
      meta: {
        title: 'T2 Golden 訓練',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.t2GoldenTraining,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-t9-deepseek-training',
      component: _import('leoKnowledge/T9DeepseekTraining'),
      name: 'leoT9DeepseekTraining',
      meta: {
        title: 'T9 DeepSeek 訓練',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.t9DeepseekTraining,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-production-e2e-training',
      component: _import('leoKnowledge/ProductionE2eTraining'),
      name: 'leoProductionE2eTraining',
      meta: {
        title: 'T6 生產 E2E 訓練',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.productionE2eTraining,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-training-federation-cases',
      component: _import('leoKnowledge/ProductionE2eTraining'),
      name: 'leoTrainingFederationCases',
      meta: {
        title: '联邦样本浏览',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCases,
        id: LEO_KNOWLEDGE_MENU_IDS.trainingFederationCases,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-turn-routing-training',
      component: _import('leoKnowledge/TurnRoutingTrainingHub'),
      name: 'leoTurnRoutingTrainingHub',
      meta: {
        title: i18n.t('route.leoTurnRoutingTrainingHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining,
        id: LEO_KNOWLEDGE_MENU_IDS.turnRoutingTraining,
        leoKnowledgeAnyOf: [LEO_KNOWLEDGE_PERM_CODES.VIEW, LEO_KNOWLEDGE_PERM_CODES.UPLOAD]
      }
    },
    {
      path: '/leo-portal-ops-daily-hub',
      component: _import('leoKnowledge/PortalOpsDailyHub'),
      name: 'leoKnowledgePortalOpsDailyHub',
      meta: {
        title: i18n.t('route.leoKnowledgePortalOpsDailyHub'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub,
        id: LEO_KNOWLEDGE_MENU_IDS.portalOpsDailyHub,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-portal-ops-api-inventory',
      component: _import('leoKnowledge/PortalOpsInventoryConsole'),
      name: 'leoKnowledgePortalOpsInventory',
      meta: {
        title: i18n.t('route.leoKnowledgePortalOpsInventory'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole,
        id: LEO_KNOWLEDGE_MENU_IDS.portalOpsInventoryConsole,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-review-inbox',
      component: _import('leoKnowledge/DeviceOpsReviewInbox'),
      name: 'leoDeviceOpsReviewInbox',
      meta: {
        title: i18n.t('route.leoDeviceOpsReviewInbox'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsReviewInbox,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-command-onboarding-wizard',
      component: _import('leoKnowledge/CommandOnboardingWizard'),
      name: 'leoCommandOnboardingWizard',
      meta: {
        title: '命令定版向导',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard,
        id: LEO_KNOWLEDGE_MENU_IDS.commandOnboardingWizard,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-description-autogen',
      component: _import('leoKnowledge/DeviceOpsDescriptionAutogen'),
      name: 'leoDeviceOpsDescriptionAutogen',
      meta: {
        title: i18n.t('route.leoDeviceOpsDescriptionAutogen'),
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsDescriptionAutogen,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-device-ops-role-policy',
      component: _import('leoKnowledge/DeviceOpsRolePolicy'),
      name: 'leoDeviceOpsRolePolicy',
      meta: {
        title: '命令權限總表',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy,
        id: LEO_KNOWLEDGE_MENU_IDS.deviceOpsRolePolicy,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.UPLOAD
      }
    },
    {
      path: '/leo-knowledge-learning',
      component: _import('leoKnowledge/pipeline/LearningOutcomes'),
      name: 'leoKnowledgeLearning',
      meta: {
        title: '學習閉環',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.learning,
        id: LEO_KNOWLEDGE_MENU_IDS.learning,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/leo-knowledge-external-ingest',
      component: _import('leoKnowledge/pipeline/ExternalKnowledgeIngest'),
      name: 'leoKnowledgeExternalIngest',
      meta: {
        title: '外部知識入庫',
        isTab: true,
        isDynamic: false,
        menuId: LEO_KNOWLEDGE_MENU_IDS.externalIngest,
        id: LEO_KNOWLEDGE_MENU_IDS.externalIngest,
        leoKnowledgePermission: LEO_KNOWLEDGE_PERM_CODES.VIEW
      }
    },
    {
      path: '/linuxAuto-equipment',
      component: _import('linuxAuto/equipment/index'),
      name: 'linuxAuto-equipment',
      meta: {
        title: '車載設備',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.equipment,
        id: LINUX_AUTO_MENU_IDS.equipment
      }
    },
    {
      path: '/linuxAuto-remoteOps',
      component: _import('linuxAuto/remoteOps/index'),
      name: 'linuxAuto-remoteOps',
      meta: {
        title: '遠程運維',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.remoteOps,
        id: LINUX_AUTO_MENU_IDS.remoteOps
      }
    },
    {
      path: '/linuxAuto-profileConfig',
      component: _import('linuxAuto/profileConfig/index'),
      name: 'linuxAuto-profileConfig',
      meta: {
        title: 'Profile 配置',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.profileConfig,
        id: LINUX_AUTO_MENU_IDS.profileConfig
      }
    },
    {
      path: '/linuxAuto-dataBilling',
      component: _import('linuxAuto/dataBilling/index'),
      name: 'linuxAuto-dataBilling',
      meta: {
        title: 'CAN 數據帳單',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.dataBilling,
        id: LINUX_AUTO_MENU_IDS.dataBilling
      }
    },
    {
      path: '/linuxAuto-modelRegistry',
      component: _import('linuxAuto/modelRegistry/index'),
      name: 'linuxAuto-modelRegistry',
      meta: {
        title: '車型與 CAN 映射',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.modelRegistry,
        id: LINUX_AUTO_MENU_IDS.modelRegistry
      }
    },
    {
      path: '/linuxAuto-partnerDelivery',
      component: _import('linuxAuto/partnerDelivery/index'),
      name: 'linuxAuto-partnerDelivery',
      meta: {
        title: '合作方交付',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.partnerDelivery,
        id: LINUX_AUTO_MENU_IDS.partnerDelivery
      }
    },
    {
      path: '/linuxAuto-fleetMonitor',
      component: _import('linuxAuto/fleetMonitor/index'),
      name: 'linuxAuto-fleetMonitor',
      meta: {
        title: '車隊監控',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.fleetMonitor,
        id: LINUX_AUTO_MENU_IDS.fleetMonitor
      }
    },
    {
      path: '/linuxAuto-dbcEntitlement',
      component: _import('linuxAuto/dbcEntitlement/index'),
      name: 'linuxAuto-dbcEntitlement',
      meta: {
        title: 'DBC 通道開通',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.dbcEntitlement,
        id: LINUX_AUTO_MENU_IDS.dbcEntitlement
      }
    },
    {
      path: '/linuxAuto-cabinFeatures',
      component: _import('linuxAuto/cabinFeatures/index'),
      name: 'linuxAuto-cabinFeatures',
      meta: {
        title: '座艙能力',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.cabinFeatures,
        id: LINUX_AUTO_MENU_IDS.cabinFeatures
      }
    },
    {
      path: '/linuxAuto-canAutoMatch',
      component: _import('linuxAuto/canOnboarding/index'),
      name: 'linuxAuto-canAutoMatch',
      meta: {
        title: 'Leo 智能 CAN 接入',
        isTab: true,
        isDynamic: false,
        menuId: LINUX_AUTO_MENU_IDS.canAutoMatch,
        id: LINUX_AUTO_MENU_IDS.canAutoMatch
      }
    },
    {
      path: '/ivi-can-onboarding',
      component: _import('linuxAuto/canOnboarding/index'),
      name: 'iviCanOnboarding',
      meta: {
        title: '車機 CAN 接入',
        isTab: false,
        isDynamic: false,
        iviSurface: true
      }
    },
    {
      path: '/member-hq-dashboard',
      component: _import('hq/member/dashboard'),
      name: 'memberHqDashboard',
      meta: { title: '會員 HQ 總覽', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.dashboard, id: MEMBER_HQ_MENU_IDS.dashboard }
    },
    {
      path: '/member-hq-detail/:id',
      component: _import('hq/member/detail'),
      name: 'memberHqDetail',
      meta: { title: '會員詳情', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.detail, id: MEMBER_HQ_MENU_IDS.detail }
    },
    {
      path: '/member-hq-finance',
      component: _import('hq/member/finance'),
      name: 'memberHqFinance',
      meta: { title: '會員財務', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.finance, id: MEMBER_HQ_MENU_IDS.finance }
    },
    {
      path: '/member-hq-ops',
      component: _import('hq/member/ops'),
      name: 'memberHqOps',
      meta: { title: '會員營運', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.ops, id: MEMBER_HQ_MENU_IDS.ops }
    },
    {
      path: '/leo-um-member-admin',
      component: _import('leo/um/memberAdmin'),
      name: 'leoUmMemberAdmin',
      meta: { title: 'UM 會員管理', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.umMemberAdmin, id: MEMBER_HQ_MENU_IDS.umMemberAdmin }
    },
    {
      path: '/distributor-dashboard',
      component: _import('distributor/dashboard'),
      name: 'distributorDashboard',
      meta: { title: '渠道總覽', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.distDashboard, id: MEMBER_HQ_MENU_IDS.distDashboard }
    },
    {
      path: '/distributor-members',
      component: _import('distributor/members'),
      name: 'distributorMembers',
      meta: { title: '渠道會員', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.distMembers, id: MEMBER_HQ_MENU_IDS.distMembers }
    },
    {
      path: '/distributor-profit',
      component: _import('distributor/profit'),
      name: 'distributorProfit',
      meta: { title: '分潤明細', isTab: true, isDynamic: false, menuId: MEMBER_HQ_MENU_IDS.distProfit, id: MEMBER_HQ_MENU_IDS.distProfit }
    },
    {
      path: '/support-ticket-create',
      component: _import('support/ticket/create'),
      name: 'support-ticket-create',
      meta: { title: '提交工单', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.create, id: SUPPORT_TICKET_MENU_IDS.create, supportTicketPermission: 'support:ticket:create' }
    },
    {
      path: '/support-ticket-mine',
      component: _import('support/ticket/mine'),
      name: 'support-ticket-mine',
      meta: { title: '我的工单', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.mine, id: SUPPORT_TICKET_MENU_IDS.mine, supportTicketPermission: 'support:ticket:view:own' }
    },
    {
      path: '/support-ticket-workbench',
      component: _import('support/ticket/workbench'),
      name: 'support-ticket-workbench',
      meta: { title: '售后工作台', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.workbench, id: SUPPORT_TICKET_MENU_IDS.workbench, supportTicketPermission: 'support:ticket:manage' }
    },
    {
      path: '/support-playbook',
      component: _import('support/playbook/index'),
      name: 'support-playbook',
      meta: { title: '标准问答库', isTab: true, isDynamic: false, menuId: SUPPORT_TICKET_MENU_IDS.playbook, id: SUPPORT_TICKET_MENU_IDS.playbook, supportTicketPermission: 'support:playbook:manage' }
    },
    { path: '/device-service/workbench', redirect: '/device-service-workbench' },
    { path: '/device-service/my-assignments', redirect: '/device-service-my-assignments' },
    { path: '/device-service/assignees', redirect: '/device-service-assignees' },
    { path: '/device-service/maintenance', redirect: '/device-service-maintenance' },
    { path: '/device-service/fault-policy', redirect: '/device-service-fault-policy' },
    { path: '/device-service/enterprise-policy', redirect: '/device-service-enterprise-policy' },
    { path: '/device-service/bills', redirect: '/device-service-bills' },
    { path: '/device-service/analytics', redirect: '/device-service-analytics' },
    { path: '/device-service/h5/my-assignments', redirect: '/device-service-h5-my-assignments' },
    {
      path: '/device-service-workbench',
      component: _import('device-service/workbench'),
      name: 'device-service-workbench',
      meta: { title: 'deviceServiceWorkbench', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.workbench, id: DEVICE_SERVICE_MENU_IDS.workbench }
    },
    {
      path: '/device-service-my-assignments',
      component: _import('device-service/my-assignments'),
      name: 'device-service-my-assignments',
      meta: { title: 'deviceServiceMyAssignments', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.myAssignments, id: DEVICE_SERVICE_MENU_IDS.myAssignments }
    },
    {
      path: '/device-service-assignees',
      component: _import('device-service/assignees'),
      name: 'device-service-assignees',
      meta: { title: 'deviceServiceAssignees', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.assignees, id: DEVICE_SERVICE_MENU_IDS.assignees }
    },
    {
      path: '/device-service-maintenance',
      component: _import('device-service/maintenance'),
      name: 'device-service-maintenance',
      meta: { title: 'deviceServiceMaintenance', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.maintenance, id: DEVICE_SERVICE_MENU_IDS.maintenance }
    },
    {
      path: '/device-service-fault-policy',
      component: _import('device-service/fault-policy'),
      name: 'device-service-fault-policy',
      meta: { title: 'deviceServiceFaultPolicy', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.faultPolicy, id: DEVICE_SERVICE_MENU_IDS.faultPolicy }
    },
    {
      path: '/device-service-enterprise-policy',
      component: _import('device-service/enterprise-policy'),
      name: 'device-service-enterprise-policy',
      meta: { title: 'deviceServiceEnterprisePolicy', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.enterprisePolicy, id: DEVICE_SERVICE_MENU_IDS.enterprisePolicy }
    },
    {
      path: '/device-service-bills',
      component: _import('device-service/bills'),
      name: 'device-service-bills',
      meta: { title: 'deviceServiceBills', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.bills, id: DEVICE_SERVICE_MENU_IDS.bills }
    },
    {
      path: '/device-service-analytics',
      component: _import('device-service/analytics'),
      name: 'device-service-analytics',
      meta: { title: 'deviceServiceAnalytics', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.analytics, id: DEVICE_SERVICE_MENU_IDS.analytics }
    },
    {
      path: '/device-service-h5-my-assignments',
      component: _import('device-service/h5/my-assignments'),
      name: 'device-service-h5-my-assignments',
      meta: { title: 'deviceServiceMobile', isTab: true, isDynamic: false, menuId: DEVICE_SERVICE_MENU_IDS.mobile, id: DEVICE_SERVICE_MENU_IDS.mobile }
    },
    { path: '/store-material-stock', redirect: '/store-material-stock-page' },
    { path: '/store-material-orders', redirect: '/store-material-orders-page' },
    {
      path: '/store-material-stock-page',
      component: _import('storeMaterial/stock/index'),
      name: 'store-material-stock',
      meta: { title: 'storeMaterialStock', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.stock, id: STORE_MATERIAL_MENU_IDS.stock }
    },
    {
      path: '/store-material-orders-page',
      component: _import('storeMaterial/orders/index'),
      name: 'store-material-orders',
      meta: { title: 'storeMaterialOrders', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.orders, id: STORE_MATERIAL_MENU_IDS.orders }
    },
    {
      path: '/store-material-consumable-page',
      component: _import('storeMaterial/consumable/index'),
      name: 'store-material-consumable',
      meta: { title: 'storeMaterialConsumable', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.consumable, id: STORE_MATERIAL_MENU_IDS.consumable }
    },
    {
      path: '/store-material-mq-page',
      component: _import('storeMaterial/mq/index'),
      name: 'store-material-mq',
      meta: { title: 'storeMaterialMq', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.mq, id: STORE_MATERIAL_MENU_IDS.mq }
    },
    {
      path: '/store-material-invoice-page',
      component: _import('storeMaterial/invoice/index'),
      name: 'store-material-invoice',
      meta: { title: 'storeMaterialInvoice', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.invoice, id: STORE_MATERIAL_MENU_IDS.invoice }
    },
    {
      path: '/store-material-barcode-alias-page',
      component: _import('storeMaterial/barcodeAlias/index'),
      name: 'store-material-barcode-alias',
      meta: { title: 'storeMaterialBarcodeAlias', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.barcodeAlias, id: STORE_MATERIAL_MENU_IDS.barcodeAlias }
    },
    {
      path: '/store-material-count-page',
      component: _import('storeMaterial/count/index'),
      name: 'store-material-count',
      meta: { title: 'storeMaterialCount', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.count, id: STORE_MATERIAL_MENU_IDS.count }
    },
    {
      path: '/store-material-bom-wizard-page',
      component: _import('storeMaterial/bomWizard/index'),
      name: 'store-material-bom-wizard',
      meta: { title: 'storeMaterialBomWizard', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.bomWizard, id: STORE_MATERIAL_MENU_IDS.bomWizard }
    },
    {
      path: '/store-material-analytics-page',
      component: _import('storeMaterial/analytics/index'),
      name: 'store-material-analytics',
      meta: { title: 'storeMaterialAnalytics', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.analytics, id: STORE_MATERIAL_MENU_IDS.analytics }
    },
    {
      path: '/store-material-physical-merge-page',
      component: _import('storeMaterial/physicalMerge/index'),
      name: 'store-material-physical-merge',
      meta: { title: 'storeMaterialPhysicalMerge', isTab: true, isDynamic: false, menuId: STORE_MATERIAL_MENU_IDS.physicalMerge, id: STORE_MATERIAL_MENU_IDS.physicalMerge }
    },
    {
      path: '/finance/accountingReports',
      component: _import('finance/accountingReports/index'),
      name: 'financeAccountingReports',
      meta: { title: 'financeAccountingReports', isTab: true, isDynamic: false, menuId: FINANCE_ACCOUNTING_MENU_IDS.reports, id: FINANCE_ACCOUNTING_MENU_IDS.reports }
    },
    {
      path: '/storeCostOptimize/desk',
      component: _import('storeCostOptimize/desk/index'),
      name: 'storeCostOptimizeDesk',
      meta: { title: 'storeCostOptimizeDesk', isTab: true, isDynamic: false, menuId: STORE_COST_OPTIMIZE_MENU_IDS.desk, id: STORE_COST_OPTIMIZE_MENU_IDS.desk }
    },
    {
      path: '/storeOpsCeo/desk',
      component: _import('storeOpsCeo/desk/index'),
      name: 'storeOpsCeoDecisionDesk',
      meta: { title: 'storeOpsCeoDecisionDesk', isTab: true, isDynamic: false, menuId: STORE_OPS_CEO_DESK_MENU_IDS.desk, id: STORE_OPS_CEO_DESK_MENU_IDS.desk }
    },
    {
      path: '/aiEngineeringControl/desk',
      component: _import('aiEngineeringControl/desk/index'),
      name: 'aiEngineeringControlDesk',
      meta: { title: 'aiEngineeringControlDesk', isTab: true, isDynamic: false, menuId: AI_ENGINEERING_CONTROL_MENU_IDS.desk, id: AI_ENGINEERING_CONTROL_MENU_IDS.desk }
    },
    {
      path: '/storePnL/desk',
      component: _import('storePnL/desk/index'),
      name: 'storePnLDesk',
      meta: { title: 'storePnLDesk', isTab: true, isDynamic: false, menuId: STORE_PNL_MENU_IDS.desk, id: STORE_PNL_MENU_IDS.desk }
    },
    {
      path: '/storePnL/hk-tax',
      component: _import('storePnL/hk-tax/index'),
      name: 'hkTaxFilingDesk',
      meta: { title: 'hkTaxFilingDesk', isTab: true, isDynamic: false, menuId: HK_TAX_FILING_MENU_IDS.desk, id: HK_TAX_FILING_MENU_IDS.desk }
    },
    {
      path: '/xhmHardwarePartner/desk',
      component: _import('xhmHardwarePartner/desk/index'),
      name: 'xhmHardwarePartnerDesk',
      meta: { title: 'xhmHardwarePartnerDesk', isTab: true, isDynamic: false, menuId: XHM_HARDWARE_PARTNER_MENU_IDS.desk, id: XHM_HARDWARE_PARTNER_MENU_IDS.desk }
    },
    {
      path: '/xhmFamilySlot/desk',
      component: _import('xhmFamilySlot/desk/index'),
      name: 'xhmFamilySlotDesk',
      meta: { title: 'xhmFamilySlotDesk', isTab: true, isDynamic: false, menuId: XHM_FAMILY_SLOT_MENU_IDS.desk, id: XHM_FAMILY_SLOT_MENU_IDS.desk }
    },
    {
      path: '/leoBrandOnboarding/desk',
      component: _import('leoBrandOnboarding/desk/index'),
      name: 'leoBrandOnboardingDesk',
      meta: { title: 'leoBrandOnboardingDesk', isTab: true, isDynamic: false, menuId: LEO_BRAND_ONBOARDING_MENU_IDS.desk, id: LEO_BRAND_ONBOARDING_MENU_IDS.desk }
    },
    {
      path: '/hkMarketChannel/desk',
      component: _import('hkMarketChannel/desk/index'),
      name: 'hkMarketChannelDesk',
      meta: { title: 'hkMarketChannelDesk', isTab: true, isDynamic: false, menuId: HK_MARKET_CHANNEL_MENU_IDS.desk, id: HK_MARKET_CHANNEL_MENU_IDS.desk }
    },
    {
      path: '/hkMarketChannel/signup',
      component: _import('hkMarketChannel/signup/index'),
      name: 'hkMarketSignup',
      meta: { title: 'hkMarketSignup', isTab: true, isDynamic: false, menuId: HK_MARKET_CHANNEL_MENU_IDS.signup, id: HK_MARKET_CHANNEL_MENU_IDS.signup }
    },
    {
      path: '/cnMarketChannel/desk',
      component: _import('cnMarketChannel/desk/index'),
      name: 'cnMarketChannelDesk',
      meta: { title: 'cnMarketChannelDesk', isTab: true, isDynamic: false, menuId: CN_MARKET_CHANNEL_MENU_IDS.desk, id: CN_MARKET_CHANNEL_MENU_IDS.desk }
    },
    {
      path: '/cnMarketChannel/signup',
      component: _import('cnMarketChannel/signup/index'),
      name: 'cnMarketSignup',
      meta: { title: 'cnMarketSignup', isTab: true, isDynamic: false, menuId: CN_MARKET_CHANNEL_MENU_IDS.signup, id: CN_MARKET_CHANNEL_MENU_IDS.signup }
    },
    {
      path: '/storeOpsCeo/staffAlertSim',
      component: _import('storeOpsCeo/staffAlertSim/index'),
      name: 'storeOpsStaffAlertSim',
      meta: { title: 'storeOpsStaffAlertSim', isTab: true, isDynamic: false, menuId: STORE_OPS_CEO_DESK_MENU_IDS.desk, id: STORE_OPS_CEO_DESK_MENU_IDS.desk }
    },
    {
      path: '/storeAutonomousMarketing/desk',
      component: _import('storeAutonomousMarketing/desk/index'),
      name: 'storeAutonomousMarketingDesk',
      meta: { title: 'storeAutonomousMarketingDesk', isTab: true, isDynamic: false, menuId: STORE_AUTONOMOUS_MARKETING_MENU_IDS.desk, id: STORE_AUTONOMOUS_MARKETING_MENU_IDS.desk }
    },
    // path 用連字號對齊 DB url→routePathKey（workforce/weekSchedule → workforce-weekSchedule）
    {
      path: '/workforce-weekSchedule',
      component: _import('workforce/weekSchedule/index'),
      name: 'workforceWeekSchedule',
      meta: { title: 'workforceWeekSchedule', isTab: true, isDynamic: false, menuId: WORKFORCE_MENU_IDS.weekSchedule, id: WORKFORCE_MENU_IDS.weekSchedule }
    },
    {
      path: '/workforce-clock',
      component: _import('workforce/clock/index'),
      name: 'workforceClock',
      meta: { title: 'workforceClock', isTab: true, isDynamic: false, menuId: WORKFORCE_MENU_IDS.clock, id: WORKFORCE_MENU_IDS.clock }
    },
    {
      path: '/workforce-summary',
      component: _import('workforce/summary/index'),
      name: 'workforceSummary',
      meta: { title: 'workforceSummary', isTab: true, isDynamic: false, menuId: WORKFORCE_MENU_IDS.summary, id: WORKFORCE_MENU_IDS.summary }
    },
    {
      path: '/workforce-smartRoster',
      component: _import('workforce/smartRoster/index'),
      name: 'workforceSmartRoster',
      meta: { title: 'workforceSmartRoster', isTab: true, isDynamic: false, menuId: WORKFORCE_MENU_IDS.smartRoster, id: WORKFORCE_MENU_IDS.smartRoster }
    },
    {
      path: '/workforce-mySchedule',
      component: _import('workforce/mySchedule/index'),
      name: 'workforceMySchedule',
      meta: { title: 'workforceMySchedule', isTab: true, isDynamic: false, menuId: WORKFORCE_MENU_IDS.mySchedule, id: WORKFORCE_MENU_IDS.mySchedule }
    },
    {
      path: '/workforce-payroll',
      component: _import('workforce/payroll/index'),
      name: 'workforcePayroll',
      meta: { title: 'workforcePayroll', isTab: true, isDynamic: false, menuId: WORKFORCE_MENU_IDS.payroll, id: WORKFORCE_MENU_IDS.payroll }
    },
    { path: '/workforce/weekSchedule', redirect: '/workforce-weekSchedule' },
    { path: '/workforce/clock', redirect: '/workforce-clock' },
    { path: '/workforce/summary', redirect: '/workforce-summary' },
    { path: '/workforce/smartRoster', redirect: '/workforce-smartRoster' },
    { path: '/workforce/mySchedule', redirect: '/workforce-mySchedule' },
    { path: '/workforce/payroll', redirect: '/workforce-payroll' },
    {
      path: '/storeAutopilot-exceptions',
      component: _import('storeAutopilot/exceptions/index'),
      name: 'storeAutopilotExceptions',
      meta: { title: 'storeAutopilotExceptions', isTab: true, isDynamic: false, menuId: STORE_AUTOPILOT_MENU_IDS.exceptions, id: STORE_AUTOPILOT_MENU_IDS.exceptions }
    },
    { path: '/storeAutopilot/exceptions', redirect: '/storeAutopilot-exceptions' },
    {
      path: '/xrrossIntro-hub',
      component: _import('xrrossIntro/hub/index'),
      name: 'xrrossIntroHub',
      meta: { title: 'xrrossIntroHub', isTab: true, isDynamic: false, menuId: XRROSS_INTRO_ROUTE.hubId, id: XRROSS_INTRO_ROUTE.hubId }
    },
    { path: '/xrrossIntro/hub', redirect: '/xrrossIntro-hub' },
    {
      path: '/ecosystem-mall-topology',
      component: _import('ecosystemMall/topology'),
      name: 'ecosystemMallTopology',
      meta: { title: 'ecosystemMallTopology', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.topology, id: ECOSYSTEM_MALL_MENU_IDS.topology }
    },
    {
      path: '/ecosystem-mall-catalog',
      component: _import('ecosystemMall/catalog'),
      name: 'ecosystemMallCatalog',
      meta: { title: 'ecosystemMallCatalog', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.catalog, id: ECOSYSTEM_MALL_MENU_IDS.catalog }
    },
    {
      path: '/ecosystem-mall-home-orders',
      component: _import('ecosystemMall/homeOrders'),
      name: 'ecosystemMallHomeOrders',
      meta: { title: 'ecosystemMallHomeOrders', isTab: true, isDynamic: false }
    },
    {
      path: '/ecosystem-mall-synergy-edges',
      component: _import('ecosystemMall/synergyEdges'),
      name: 'ecosystemMallSynergyEdges',
      meta: { title: 'ecosystemMallSynergyEdges', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.synergyEdges, id: ECOSYSTEM_MALL_MENU_IDS.synergyEdges }
    },
    {
      path: '/ecosystem-mall-intents',
      component: _import('ecosystemMall/intents'),
      name: 'ecosystemMallIntents',
      meta: { title: 'ecosystemMallIntents', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.intents, id: ECOSYSTEM_MALL_MENU_IDS.intents }
    },
    {
      path: '/ecosystem-mall-vendors',
      component: _import('ecosystemMall/vendors'),
      name: 'ecosystemMallVendors',
      meta: { title: 'ecosystemMallVendors', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.vendors, id: ECOSYSTEM_MALL_MENU_IDS.vendors }
    },
    {
      path: '/ecosystem-mall-media-billing',
      component: _import('ecosystemMall/mediaBilling'),
      name: 'ecosystemMallMediaBilling',
      meta: { title: 'ecosystemMallMediaBilling', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.mediaBilling, id: ECOSYSTEM_MALL_MENU_IDS.mediaBilling }
    },
    {
      path: '/ecosystem-mall/media',
      component: _import('ecosystemMall/mediaHub'),
      name: 'ecosystemMallMediaHub',
      meta: { title: 'ecosystemMallMediaHub', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.mediaHub, id: ECOSYSTEM_MALL_MENU_IDS.mediaHub }
    },
    {
      path: '/ecosystem-mall-product-specs',
      component: _import('ecosystemMall/productSpecs'),
      name: 'ecosystemMallProductSpecs',
      meta: { title: 'ecosystemMallProductSpecs', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.productSpecs, id: ECOSYSTEM_MALL_MENU_IDS.productSpecs }
    },
    {
      path: '/ecosystem-mall-production-lines',
      component: _import('ecosystemMall/productionLines'),
      name: 'ecosystemMallLines',
      meta: { title: 'ecosystemMallLines', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.productionLines, id: ECOSYSTEM_MALL_MENU_IDS.productionLines }
    },
    {
      path: '/ecosystem-mall-search',
      component: _import('ecosystemMall/search'),
      name: 'ecosystemMallSearch',
      meta: { title: 'ecosystemMallSearch', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.search, id: ECOSYSTEM_MALL_MENU_IDS.search }
    },
    {
      path: '/ecosystem-mall/product-knowledge',
      component: _import('ecosystemMall/productKnowledge'),
      name: 'ecosystemMallProductKnowledge',
      meta: { title: 'ecosystemMallProductKnowledge', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.productKnowledge, id: ECOSYSTEM_MALL_MENU_IDS.productKnowledge }
    },
    {
      path: '/ecosystem-mall/trial-sim',
      component: _import('ecosystemMall/trialSimulators'),
      name: 'ecosystemMallTrialSim',
      meta: { title: 'ecosystemMallTrialSim', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.trialSim, id: ECOSYSTEM_MALL_MENU_IDS.trialSim }
    },
    {
      path: '/ecosystem-mall/virtual-workspace',
      component: _import('ecosystemMall/virtualWorkspace'),
      name: 'ecosystemMallVirtualWorkspace',
      meta: { title: 'ecosystemMallVirtualWorkspace', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.virtualWorkspace, id: ECOSYSTEM_MALL_MENU_IDS.virtualWorkspace }
    },
    {
      path: '/ecosystem-mall-virtual-workspace',
      redirect: '/ecosystem-mall/virtual-workspace'
    },
    {
      path: '/ecosystem-mall/equipment-demands',
      component: _import('ecosystemMall/equipmentDemands'),
      name: 'ecosystemMallEquipmentDemands',
      meta: { title: 'ecosystemMallEquipmentDemands', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.equipmentDemands, id: ECOSYSTEM_MALL_MENU_IDS.equipmentDemands }
    },
    {
      path: '/storeAssortment/desk',
      component: _import('storeAssortment/desk/index'),
      name: 'storeAssortmentDesk',
      meta: { title: 'storeAssortmentDesk', isTab: true, isDynamic: false, menuId: STORE_ASSORTMENT_MENU_IDS.desk, id: STORE_ASSORTMENT_MENU_IDS.desk }
    },
    {
      path: '/store-assortment-optimization',
      redirect: '/storeAssortment/desk'
    },
    {
      path: '/ecosystem-mall-equipment-demands',
      redirect: '/ecosystem-mall/equipment-demands'
    },
    {
      path: '/ecosystem-mall/business-plans',
      component: _import('ecosystemMall/businessPlans'),
      name: 'ecosystemMallBusinessPlans',
      meta: { title: 'ecosystemMallBusinessPlans', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.businessPlans, id: ECOSYSTEM_MALL_MENU_IDS.businessPlans }
    },
    {
      path: '/ecosystem-mall/website-pages',
      component: _import('ecosystemMall/websitePages'),
      name: 'ecosystemMallWebsitePages',
      meta: { title: 'ecosystemMallWebsitePages', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.websitePages, id: ECOSYSTEM_MALL_MENU_IDS.websitePages }
    },
    {
      path: '/ecosystem-mall/combo-sim',
      component: _import('ecosystemMall/comboSimDemo'),
      name: 'ecosystemMallComboSim',
      meta: { title: 'ecosystemMallComboSim', isTab: true, isDynamic: false, menuId: ECOSYSTEM_MALL_MENU_IDS.productionLines, id: ECOSYSTEM_MALL_MENU_IDS.productionLines }
    },
    {
      path: '/dataCenter-teaMachineMaterial-index',
      component: _import('dataCenter/teaMachineMaterial/index'),
      name: 'teaMachineMaterial',
      meta: {
        title: 'teaMachineMaterial',
        isTab: true,
        isDynamic: false,
        menuId: TEA_MACHINE_MATERIAL_MENU_IDS.page,
        id: TEA_MACHINE_MATERIAL_MENU_IDS.page
      }
    },
    {
      path: '/dataCenter-teaEarlyBrew-index',
      component: _import('dataCenter/teaEarlyBrew/index'),
      name: 'teaEarlyBrewWork',
      meta: {
        title: 'teaEarlyBrewWork',
        isTab: true,
        isDynamic: false,
        menuId: TEA_EARLY_BREW_WORK_MENU_IDS.page,
        id: TEA_EARLY_BREW_WORK_MENU_IDS.page
      }
    },
    {
      path: '/dataCenter-teaDataStatistics-singleCupParams',
      component: _import('dataCenter/teaDataStatistics/singleCupParams'),
      name: 'teaSingleCupParams',
      meta: {
        title: 'teaSingleCupParams',
        isTab: true,
        isDynamic: false,
        menuId: TEA_SINGLE_CUP_PARAMS_MENU_IDS.page,
        id: TEA_SINGLE_CUP_PARAMS_MENU_IDS.page
      }
    },
    {
      path: '/dataCenter-teaE1Performance-index',
      component: _import('dataCenter/teaE1Performance/index'),
      name: 'teaE1Performance',
      meta: {
        title: 'teaE1Performance',
        isTab: true,
        isDynamic: false,
        menuId: TEA_E1_PERFORMANCE_MENU_IDS.page,
        id: TEA_E1_PERFORMANCE_MENU_IDS.page
      }
    },

    {
      path: '/image-order-produceFivePos',
      component: _import('image/order/produceFivePos'),
      name: 'image-order-produceFivePos',
      meta: {
        title: i18n.t('route.produceFivePos'),
        isTab: true,
        isDynamic: false,
        menuId: PRODUCE_FIVE_POS_MENU_ID,
        id: PRODUCE_FIVE_POS_MENU_ID
      }
    },
    {
      path: '/dataCenter-machineDataStatistics-useStatistics',
      component: _import('dataCenter/machineDataStatistics/useStatistics'),
      name: 'devicesWorkingData',
      meta: {
        title: 'devicesWorkingData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-machineData-index',
      component: _import('dataCenter/machineData/index'),
      name: 'devicsData',
      meta: {
        title: 'devicsData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-merchantData-index',
      component: _import('dataCenter/merchantData/index'),
      name: 'merchantsData',
      meta: {
        title: 'merchantsData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-produceData-index',
      component: _import('dataCenter/produceData/index'),
      name: 'dataCenter-produceData-index',
      meta: {
        title: 'productionData',
        isTab: true,
        isDynamic: false
      }
    },
    {
      path: '/dataCenter-machineDataStatistics-productStatistics',
      component: _import('dataCenter/machineDataStatistics/productStatistics'),
      name: 'coffeeMachineProductionData',
      meta: {
        title: 'coffeeMachineProductionData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.productionData,
        id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.productionData
      }
    },
    {
      path: '/dataCenter-machineDataStatistics-singleProductStatistics',
      component: _import('dataCenter/machineDataStatistics/singleProductStatistics'),
      name: 'coffeeMachineSingleCupData',
      meta: {
        title: 'coffeeMachineSingleCupData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.singleCupData,
        id: DATA_CENTER_COFFEE_MACHINE_MENU_IDS.singleCupData
      }
    },
    {
      path: '/dataCenter-blendProduceDataStatistics-productStatistics',
      component: _import('dataCenter/blendProduceDataStatistics/productStatistics'),
      name: 'dataCenter-blendProduceDataStatistics-productStatistics',
      meta: {
        title: 'beverageOutputData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_BLEND_MENU_IDS.productionData,
        id: DATA_CENTER_BLEND_MENU_IDS.productionData
      }
    },
    {
      path: '/dataCenter-blendProduceDataStatistics-singleProductStatistics',
      component: _import('dataCenter/blendProduceDataStatistics/singleProductStatistics'),
      name: 'dataCenter-blendProduceDataStatistics-singleProductStatistics',
      meta: {
        title: 'singleCupData',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_BLEND_MENU_IDS.singleCupData,
        id: DATA_CENTER_BLEND_MENU_IDS.singleCupData
      }
    },
    {
      path: '/dataCenter-blendProduceDataStatistics-logRecord',
      component: _import('dataCenter/blendProduceDataStatistics/logRecord'),
      name: 'dataCenter-blendProduceDataStatistics-logRecord',
      meta: {
        title: 'faultLog',
        isTab: true,
        isDynamic: false,
        menuId: DATA_CENTER_BLEND_MENU_IDS.faultLog,
        id: DATA_CENTER_BLEND_MENU_IDS.faultLog
      }
    }
  ]
  if (!Array.isArray(routes)) {
    return
  }
  extras.forEach((extra) => {
    if (!extra || !extra.path) {
      return
    }
    if (extra.redirect && !extra.name) {
      routes.push(extra)
      return
    }
    if (!extra.name) {
      return
    }
    const exPath = pathKey(extra.path)
    const exMenuId = extra.meta && extra.meta.menuId != null ? Number(extra.meta.menuId) : null
    for (var i = routes.length - 1; i >= 0; i--) {
      const cur = routes[i]
      if (!cur) {
        continue
      }
      const curMenuId = cur.meta && cur.meta.menuId != null ? Number(cur.meta.menuId) : null
      const sameMenuId = exMenuId != null && curMenuId === exMenuId
      if (cur.name === extra.name || pathKey(cur.path) === exPath || sameMenuId) {
        routes.splice(i, 1)
      }
    }
    routes.push(extra)
  })
}

function pushDynamicMenuRouteFromItem (menuItem, routes) {
  if (!menuItem || !menuItem.url || !/\S/.test(menuItem.url)) return
  if (isDeviceServiceMenuItem(menuItem)) return
  if (isLeoE1MenuItem(menuItem)) return
  if (isWorkforceMenuItem(menuItem)) return
  if (isStoreAutopilotMenuItem(menuItem)) return
  if (isXrrossIntroMenuItem(menuItem)) return
  menuItem.url = menuItem.url.replace(/^\//, '')
  const routePathKey = menuItem.url.replace(/\//g, '-')
  // 多设备共用 enName（如 beverageOutputData / productionData / singleCupData）时，
  // 若用 enName 作 route.name，dedupeDynamicRoutesAgainstStatic 会只保留首条 → 配料机等页无法打开。
  const routeName = routePathKey
  var route = {
    path: routePathKey,
    component: null,
    name: routeName,
    meta: {
      menuId: menuItem.id,
      title: menuItem.enName,
      isDynamic: true,
      isTab: true,
      iframeUrl: ''
    }
  }
  if (isURL(menuItem.url)) {
    route['path'] = `i-${menuItem.id}`
    route['name'] = `i-${menuItem.id}`
    route['meta']['iframeUrl'] = menuItem.url
  } else {
    try {
      route['component'] = _import(`${menuItem.url}`) || null
    } catch (e) {}
  }
  routes.push(route)
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].menuList != null && menuList[i].menuList.length >= 1) {
      temp = temp.concat(menuList[i].menuList)
    }
    pushDynamicMenuRouteFromItem(menuList[i], routes)
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    appendStaticDeviceConfigRoutes(routes)
    routes = dedupeDynamicRoutesAgainstStatic(routes)
    routes = dedupeRoutesByMenuIdPreferStatic(routes)
    mainRoutes.name = 'main'
    const mergedChildren = dedupeMainChildrenFirstWins(STATIC_MAIN_CHILDREN_SNAPSHOT.concat(routes))
    mainRoutes.children = mergedChildren
    const mainForMatcher = {
      path: '/',
      component: mainRoutes.component,
      name: 'main',
      redirect: mainRoutes.redirect,
      meta: mainRoutes.meta,
      children: mergedChildren,
      beforeEnter: mainRoutes.beforeEnter
    }
    replaceRouterMatcher(
      globalRoutes.concat([
        mainForMatcher,
        { path: '*', redirect: { name: '404' } }
      ])
    )
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
  }
}

/**
 * menuApi／permission 非 401 失敗時，仍要能用靜態 main 子路由 + 空動態菜單進入首頁
 *（避免從 /dataShow 點「进入平台」時一直 next(false)）
 */
function applyEmptyDynamicMenuFallback () {
  if (router.options.isAddDynamicMenuRoutes) return
  try {
    fnAddDynamicMenuRoutes([])
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[router] applyEmptyDynamicMenuFallback', e)
    }
  }
  router.options.isAddDynamicMenuRoutes = true
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js